/* eslint-disable max-len */

export const Learnsets: {[k: string]: ModdedLearnsetData} = {
	bulbasaur: {
		learnset: {
			doubleedge: ["7L32"],
			facade: ["7M"],
			growl: ["7L1", "7S0"],
			growth: ["7L27"],
			headbutt: ["7M"],
			leechseed: ["7L9", "7S0"],
			lightscreen: ["7M"],
			megadrain: ["7M"],
			outrage: ["7M"],
			poisonpowder: ["7L14"],
			protect: ["7M"],
			razorleaf: ["7L23"],
			reflect: ["7M"],
			rest: ["7M"],
			sleeppowder: ["7L14"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			tackle: ["7L1", "7S0"],
			takedown: ["7L18"],
			toxic: ["7M"],
			vinewhip: ["7L5", "7S0"],
		},
		eventData: [
			{generation: 7, level: 12, shiny: 1, ivs: {hp: 31, atk: 25, def: 30, spa: 25, spd: 30, spe: 25}, moves: ["leechseed", "vinewhip", "growl", "tackle"], pokeball: "pokeball"},
		],
	},
	ivysaur: {
		learnset: {
			doubleedge: ["7L48"],
			facade: ["7M"],
			growl: ["7L1"],
			growth: ["7L39"],
			headbutt: ["7M"],
			leechseed: ["7L9", "7L1"],
			lightscreen: ["7M"],
			megadrain: ["7M"],
			outrage: ["7M"],
			poisonpowder: ["7L14"],
			protect: ["7M"],
			razorleaf: ["7L31"],
			reflect: ["7M"],
			rest: ["7M"],
			sleeppowder: ["7L14"],
			sludgebomb: ["7M"],
			solarbeam: ["7M", "7L56"],
			substitute: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L22"],
			toxic: ["7M"],
			vinewhip: ["7L5", "7L1"],
		},
	},
	venusaur: {
		learnset: {
			amnesia: ["7L1"],
			doubleedge: ["7L58"],
			earthquake: ["7M"],
			facade: ["7M"],
			growl: ["7L1"],
			growth: ["7L44"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			leechseed: ["7L9", "7L1"],
			lightscreen: ["7M"],
			megadrain: ["7M"],
			outrage: ["7M"],
			petaldance: ["7L1", "7L0"],
			poisonpowder: ["7L14"],
			powerwhip: ["7L1"],
			protect: ["7M"],
			razorleaf: ["7L31"],
			reflect: ["7M"],
			rest: ["7M"],
			sleeppowder: ["7L14"],
			sludgebomb: ["7M"],
			solarbeam: ["7M", "7L71"],
			substitute: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L22"],
			toxic: ["7M"],
			vinewhip: ["7L5", "7L1"],
		},
	},
	charmander: {
		learnset: {
			brickbreak: ["7M"],
			dig: ["7M"],
			dragonpulse: ["7M"],
			dragonrage: ["7L22"],
			ember: ["7L13", "7S0"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			firespin: ["7L27"],
			flamethrower: ["7M", "7L36"],
			furyswipes: ["7L18"],
			growl: ["7L4", "7S0"],
			headbutt: ["7M"],
			irontail: ["7M"],
			outrage: ["7M"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			scratch: ["7L1", "7S0"],
			seismictoss: ["7M"],
			slash: ["7L31"],
			smokescreen: ["7L9", "7S0"],
			substitute: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
			willowisp: ["7M"],
		},
		eventData: [
			{generation: 7, level: 14, shiny: 1, ivs: {hp: 25, atk: 30, def: 25, spa: 30, spd: 25, spe: 31}, moves: ["ember", "smokescreen", "growl", "scratch"], pokeball: "pokeball"},
		],
	},
	charmeleon: {
		learnset: {
			brickbreak: ["7M"],
			dig: ["7M"],
			dragonpulse: ["7M"],
			dragonrage: ["7L26"],
			ember: ["7L13", "7L1"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			firespin: ["7L33"],
			flamethrower: ["7M", "7L46"],
			furyswipes: ["7L20"],
			growl: ["7L4", "7L1"],
			headbutt: ["7M"],
			irontail: ["7M"],
			outrage: ["7M"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			scratch: ["7L1"],
			seismictoss: ["7M"],
			slash: ["7L39"],
			smokescreen: ["7L9", "7L1"],
			substitute: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
			willowisp: ["7M"],
		},
	},
	charizard: {
		learnset: {
			airslash: ["7L62"],
			brickbreak: ["7M"],
			counter: ["7L1"],
			crunch: ["7L1"],
			dig: ["7M"],
			dragonpulse: ["7M"],
			dragonrage: ["7L26"],
			dragontail: ["7M"],
			earthquake: ["7M"],
			ember: ["7L13", "7L1"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			firespin: ["7L33"],
			flamethrower: ["7M", "7L54"],
			flareblitz: ["7L75"],
			fly: ["7M"],
			furyswipes: ["7L20"],
			growl: ["7L4", "7L1"],
			headbutt: ["7M"],
			heatwave: ["7L1"],
			hyperbeam: ["7M"],
			irontail: ["7M"],
			outrage: ["7M"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			roost: ["7M"],
			scratch: ["7L1"],
			seismictoss: ["7M"],
			slash: ["7L43"],
			smokescreen: ["7L9", "7L1"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
			willowisp: ["7M"],
			wingattack: ["7L1", "7L0"],
		},
	},
	squirtle: {
		learnset: {
			bite: ["7L23"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			bubble: ["7L9", "7S0"],
			bubblebeam: ["7L27"],
			dig: ["7M"],
			dragonpulse: ["7M"],
			facade: ["7M"],
			headbutt: ["7M", "7L36"],
			hydropump: ["7L41"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			outrage: ["7M"],
			protect: ["7M", "7L32"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			scald: ["7M"],
			seismictoss: ["7M"],
			skullbash: ["7L45"],
			substitute: ["7M"],
			surf: ["7M"],
			tackle: ["7L1", "7S0"],
			tailwhip: ["7L5", "7S0"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L18"],
			withdraw: ["7L14", "7S0"],
		},
		eventData: [
			{generation: 7, level: 16, shiny: 1, ivs: {hp: 25, atk: 25, def: 30, spa: 31, spd: 30, spe: 25}, moves: ["withdraw", "bubble", "tailwhip", "tackle"], pokeball: "pokeball"},
		],
	},
	wartortle: {
		learnset: {
			bite: ["7L27"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			bubble: ["7L9", "7L1"],
			bubblebeam: ["7L33"],
			dig: ["7M"],
			dragonpulse: ["7M"],
			facade: ["7M"],
			headbutt: ["7M", "7L46"],
			hydropump: ["7L53"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			outrage: ["7M"],
			protect: ["7M", "7L40"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			scald: ["7M"],
			seismictoss: ["7M"],
			skullbash: ["7L59"],
			substitute: ["7M"],
			surf: ["7M"],
			tackle: ["7L1"],
			tailwhip: ["7L5", "7L1"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L20"],
			withdraw: ["7L14", "7L1"],
		},
	},
	blastoise: {
		learnset: {
			aquajet: ["7L1"],
			bite: ["7L27"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			bubble: ["7L9", "7L1"],
			bubblebeam: ["7L33"],
			darkpulse: ["7M"],
			dig: ["7M"],
			dragonpulse: ["7M"],
			dragontail: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fakeout: ["7L1"],
			flashcannon: ["7M", "7L1"],
			headbutt: ["7M", "7L54"],
			hydropump: ["7L65"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			outrage: ["7M"],
			protect: ["7M", "7L44"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			scald: ["7M"],
			seismictoss: ["7M"],
			skullbash: ["7L75"],
			substitute: ["7M"],
			surf: ["7M"],
			tackle: ["7L1"],
			tailwhip: ["7L5", "7L1"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L20"],
			withdraw: ["7L14", "7L1"],
		},
	},
	caterpie: {
		learnset: {
			stringshot: ["7L1"],
			tackle: ["7L1"],
		},
	},
	metapod: {
		learnset: {
			harden: ["7L1", "7L0"],
		},
	},
	butterfree: {
		learnset: {
			airslash: ["7L28"],
			bugbuzz: ["7L31"],
			confusion: ["7L1"],
			dreameater: ["7M"],
			facade: ["7M"],
			gust: ["7L1", "7L0"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			megadrain: ["7M"],
			poisonpowder: ["7L13"],
			protect: ["7M"],
			psybeam: ["7L16"],
			psychic: ["7M"],
			quiverdance: ["7L22"],
			reflect: ["7M"],
			rest: ["7M"],
			roost: ["7M"],
			shadowball: ["7M"],
			sleeppowder: ["7L13"],
			solarbeam: ["7M"],
			stunspore: ["7L13"],
			substitute: ["7M"],
			supersonic: ["7L19"],
			teleport: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			whirlwind: ["7L25"],
		},
	},
	weedle: {
		learnset: {
			poisonsting: ["7L1"],
			stringshot: ["7L1"],
		},
	},
	kakuna: {
		learnset: {
			harden: ["7L1", "7L0"],
		},
	},
	beedrill: {
		learnset: {
			agility: ["7L25"],
			brickbreak: ["7M"],
			drillrun: ["7M"],
			facade: ["7M"],
			focusenergy: ["7L19"],
			furyattack: ["7L16"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			megadrain: ["7M"],
			outrage: ["7M", "7L31"],
			peck: ["7L1"],
			pinmissile: ["7L28"],
			poisonjab: ["7M", "7L22"],
			protect: ["7M"],
			rage: ["7L13"],
			reflect: ["7M"],
			rest: ["7M"],
			roost: ["7M"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			toxic: ["7M"],
			twineedle: ["7L1", "7L0"],
			uturn: ["7M"],
			xscissor: ["7M"],
		},
	},
	pidgey: {
		learnset: {
			agility: ["7L23"],
			airslash: ["7L27"],
			facade: ["7M"],
			fly: ["7M"],
			gust: ["7L5"],
			headbutt: ["7M"],
			mirrormove: ["7L9"],
			protect: ["7M"],
			quickattack: ["7L11"],
			razorwind: ["7L29"],
			reflect: ["7M"],
			rest: ["7M"],
			roost: ["7M", "7L17"],
			sandattack: ["7L3"],
			substitute: ["7M"],
			tackle: ["7L1"],
			toxic: ["7M"],
			uturn: ["7M"],
			whirlwind: ["7L21"],
			wingattack: ["7L15"],
		},
	},
	pidgeotto: {
		learnset: {
			agility: ["7L31"],
			airslash: ["7L39"],
			facade: ["7M"],
			fly: ["7M"],
			gust: ["7L5", "7L1"],
			headbutt: ["7M"],
			mirrormove: ["7L11"],
			protect: ["7M"],
			quickattack: ["7L9", "7L1"],
			razorwind: ["7L45"],
			reflect: ["7M"],
			rest: ["7M"],
			roost: ["7M", "7L17"],
			sandattack: ["7L3", "7L1"],
			substitute: ["7M"],
			tackle: ["7L1"],
			toxic: ["7M"],
			uturn: ["7M"],
			whirlwind: ["7L25"],
			wingattack: ["7L15"],
		},
	},
	pidgeot: {
		learnset: {
			agility: ["7L31"],
			airslash: ["7L43"],
			facade: ["7M"],
			fly: ["7M"],
			gust: ["7L5", "7L1"],
			headbutt: ["7M"],
			heatwave: ["7L1"],
			hyperbeam: ["7M"],
			mirrormove: ["7L11"],
			protect: ["7M"],
			quickattack: ["7L9", "7L1"],
			razorwind: ["7L53"],
			reflect: ["7M"],
			rest: ["7M"],
			roost: ["7M", "7L17"],
			sandattack: ["7L3", "7L1"],
			skyattack: ["7L1"],
			substitute: ["7M"],
			tackle: ["7L1"],
			toxic: ["7M"],
			uturn: ["7M"],
			whirlwind: ["7L25"],
			wingattack: ["7L15"],
		},
	},
	rattata: {
		learnset: {
			bite: ["7L12"],
			blizzard: ["7M"],
			crunch: ["7L18"],
			dig: ["7M"],
			doubleedge: ["7L27"],
			facade: ["7M"],
			focusenergy: ["7L9"],
			headbutt: ["7M"],
			hyperfang: ["7L21"],
			icebeam: ["7M"],
			irontail: ["7M"],
			protect: ["7M"],
			quickattack: ["7L6"],
			rest: ["7M"],
			shadowball: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L24"],
			superfang: ["7L15"],
			tackle: ["7L1"],
			tailwhip: ["7L3"],
			taunt: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
	},
	rattataalola: {
		learnset: {
			bite: ["7L12"],
			blizzard: ["7M"],
			crunch: ["7L18"],
			darkpulse: ["7M"],
			dig: ["7M"],
			doubleedge: ["7L27"],
			facade: ["7M"],
			focusenergy: ["7L9"],
			headbutt: ["7M"],
			hyperfang: ["7L21"],
			icebeam: ["7M"],
			irontail: ["7M"],
			protect: ["7M"],
			quickattack: ["7L6"],
			rest: ["7M"],
			shadowball: ["7M"],
			sludgebomb: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L24"],
			superfang: ["7L15"],
			tackle: ["7L1"],
			tailwhip: ["7L3"],
			taunt: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
	},
	raticate: {
		learnset: {
			bite: ["7L12"],
			blizzard: ["7M"],
			counter: ["7L1"],
			crunch: ["7L18"],
			dig: ["7M"],
			doubleedge: ["7L42"],
			facade: ["7M"],
			focusenergy: ["7L9", "7L1"],
			furyswipes: ["7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			hyperfang: ["7L26"],
			icebeam: ["7M"],
			irontail: ["7M"],
			protect: ["7M"],
			quickattack: ["7L6", "7L1"],
			rest: ["7M"],
			shadowball: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L34"],
			superfang: ["7L15"],
			swordsdance: ["7L1"],
			tackle: ["7L1"],
			tailwhip: ["7L3", "7L1"],
			taunt: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
	},
	raticatealola: {
		learnset: {
			bite: ["7L12"],
			blizzard: ["7M"],
			bulkup: ["7M"],
			counter: ["7L1"],
			crunch: ["7L18"],
			darkpulse: ["7M"],
			dig: ["7M"],
			doubleedge: ["7L42"],
			facade: ["7M"],
			focusenergy: ["7L9", "7L1"],
			furyswipes: ["7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			hyperfang: ["7L26"],
			icebeam: ["7M"],
			irontail: ["7M"],
			protect: ["7M"],
			quickattack: ["7L6", "7L1"],
			rest: ["7M"],
			shadowball: ["7M"],
			sludgebomb: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L34"],
			superfang: ["7L15"],
			swordsdance: ["7L1"],
			tackle: ["7L1"],
			tailwhip: ["7L3", "7L1"],
			taunt: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
	},
	spearow: {
		learnset: {
			agility: ["7L27"],
			drillpeck: ["7L32"],
			drillrun: ["7M"],
			facade: ["7M"],
			fly: ["7M"],
			focusenergy: ["7L11"],
			furyattack: ["7L16"],
			growl: ["7L3"],
			headbutt: ["7M"],
			leer: ["7L8"],
			mirrormove: ["7L19"],
			peck: ["7L1"],
			protect: ["7M"],
			rest: ["7M"],
			roost: ["7M", "7L24"],
			substitute: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
			uturn: ["7M"],
		},
	},
	fearow: {
		learnset: {
			agility: ["7L37"],
			drillpeck: ["7L47"],
			drillrun: ["7M", "7L1"],
			facade: ["7M"],
			fly: ["7M"],
			focusenergy: ["7L11", "7L1"],
			furyattack: ["7L16"],
			growl: ["7L3", "7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			leer: ["7L8", "7L1"],
			mirrormove: ["7L19"],
			peck: ["7L1"],
			protect: ["7M"],
			quickattack: ["7L1"],
			rest: ["7M"],
			roost: ["7M", "7L29"],
			skyattack: ["7L1"],
			substitute: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
			uturn: ["7M"],
		},
	},
	ekans: {
		learnset: {
			acid: ["7L8"],
			bite: ["7L12"],
			darkpulse: ["7M"],
			dig: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			glare: ["7L20"],
			haze: ["7L16"],
			headbutt: ["7M"],
			irontail: ["7M"],
			leer: ["7L4"],
			megadrain: ["7M"],
			poisonjab: ["7M", "7L24"],
			poisonsting: ["7L1"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			screech: ["7L32"],
			slam: ["7L28"],
			sludgebomb: ["7M"],
			substitute: ["7M"],
			toxic: ["7M", "7L36"],
			wrap: ["7L1"],
		},
	},
	arbok: {
		learnset: {
			acid: ["7L9", "7L1"],
			bite: ["7L12"],
			crunch: ["7L1", "7L0"],
			darkpulse: ["7M"],
			dig: ["7M"],
			dragontail: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			glare: ["7L20"],
			haze: ["7L16"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			irontail: ["7M"],
			leer: ["7L4", "7L1"],
			megadrain: ["7M"],
			poisonjab: ["7M", "7L28"],
			poisonsting: ["7L1"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			screech: ["7L44"],
			slam: ["7L36"],
			sludgebomb: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L1"],
			toxic: ["7M", "7L52"],
			wrap: ["7L1"],
		},
	},
	pikachu: {
		learnset: {
			agility: ["7L27"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			dig: ["7M"],
			doublekick: ["7L9"],
			doubleteam: ["7L12"],
			facade: ["7M"],
			growl: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M", "7L18"],
			payday: ["7M"],
			protect: ["7M"],
			quickattack: ["7L6"],
			reflect: ["7M"],
			rest: ["7M"],
			seismictoss: ["7M"],
			slam: ["7L24"],
			substitute: ["7M"],
			tailwhip: ["7L3"],
			thunder: ["7M", "7L30"],
			thunderbolt: ["7M", "7L21"],
			thunderpunch: ["7M"],
			thundershock: ["7L1"],
			thunderwave: ["7M", "7L15"],
			toxic: ["7M"],
		},
	},
	pikachustarter: {
		inherit: true,
		learnset: {
			agility: ["7L27"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			dig: ["7M"],
			doublekick: ["7L9"],
			doubleteam: ["7L12"],
			facade: ["7M"],
			floatyfall: ["7T"],
			growl: ["7L1", "7S0"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M", "7L18"],
			payday: ["7M"],
			pikapapow: ["7T"],
			protect: ["7M"],
			quickattack: ["7L6"],
			reflect: ["7M"],
			rest: ["7M"],
			seismictoss: ["7M"],
			slam: ["7L24"],
			splishysplash: ["7T"],
			substitute: ["7M"],
			tailwhip: ["7L3", "7S0"],
			thunder: ["7M", "7L30"],
			thunderbolt: ["7M", "7L21"],
			thunderpunch: ["7M"],
			thundershock: ["7L1", "7S0"],
			thunderwave: ["7M", "7L15"],
			toxic: ["7M"],
			zippyzap: ["7T"],
		},
	},
	raichu: {
		learnset: {
			brickbreak: ["7M"],
			calmmind: ["7M"],
			dig: ["7M"],
			encore: ["7L1"],
			facade: ["7M"],
			fakeout: ["7L1"],
			growl: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M"],
			payday: ["7M"],
			protect: ["7M"],
			quickattack: ["7L1"],
			reflect: ["7M"],
			rest: ["7M"],
			seismictoss: ["7M"],
			substitute: ["7M"],
			tailwhip: ["7L1"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M", "7L1", "7L0"],
			thundershock: ["7L1"],
			thunderwave: ["7M"],
			toxic: ["7M"],
		},
	},
	raichualola: {
		learnset: {
			brickbreak: ["7M"],
			calmmind: ["7M"],
			dig: ["7M"],
			doubleteam: ["7L1"],
			encore: ["7L1"],
			facade: ["7M"],
			fakeout: ["7L1"],
			growl: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M"],
			payday: ["7M"],
			protect: ["7M"],
			psychic: ["7M", "7L1", "7L0"],
			reflect: ["7M"],
			rest: ["7M"],
			seismictoss: ["7M"],
			substitute: ["7M"],
			tailwhip: ["7L1"],
			teleport: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			thundershock: ["7L1"],
			thunderwave: ["7M"],
			toxic: ["7M"],
		},
	},
	sandshrew: {
		learnset: {
			brickbreak: ["7M"],
			defensecurl: ["7L1"],
			dig: ["7M", "7L20"],
			earthquake: ["7M", "7L36"],
			facade: ["7M"],
			furyswipes: ["7L16"],
			headbutt: ["7M"],
			irontail: ["7M"],
			poisonjab: ["7M"],
			poisonsting: ["7L4"],
			protect: ["7M", "7L24"],
			rest: ["7M"],
			rockslide: ["7M"],
			sandattack: ["7L8"],
			scratch: ["7L1"],
			seismictoss: ["7M"],
			slash: ["7L32"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			swift: ["7L12"],
			swordsdance: ["7L28"],
			toxic: ["7M"],
			xscissor: ["7M"],
		},
	},
	sandshrewalola: {
		learnset: {
			bide: ["7L4"],
			blizzard: ["7M", "7L36"],
			brickbreak: ["7M"],
			defensecurl: ["7L1"],
			dig: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			furyswipes: ["7L20"],
			headbutt: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M", "7L24"],
			iceshard: ["7L8"],
			irontail: ["7M"],
			mirrorcoat: ["7L16"],
			poisonjab: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			scratch: ["7L1"],
			seismictoss: ["7M"],
			slash: ["7L32"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			swift: ["7L12"],
			swordsdance: ["7L28"],
			toxic: ["7M"],
			xscissor: ["7M"],
		},
	},
	sandslash: {
		learnset: {
			brickbreak: ["7M"],
			counter: ["7L1"],
			defensecurl: ["7L1"],
			dig: ["7M", "7L20"],
			drillrun: ["7M"],
			earthquake: ["7M", "7L52"],
			facade: ["7M"],
			furyswipes: ["7L16"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			irontail: ["7M"],
			poisonjab: ["7M"],
			poisonsting: ["7L4", "7L1"],
			protect: ["7M", "7L28"],
			rest: ["7M"],
			rockslide: ["7M"],
			sandattack: ["7L8", "7L1"],
			scratch: ["7L1"],
			seismictoss: ["7M"],
			slash: ["7L44"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			swift: ["7L12"],
			swordsdance: ["7L36"],
			toxic: ["7M"],
			xscissor: ["7M"],
		},
	},
	sandslashalola: {
		learnset: {
			bide: ["7L1"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			counter: ["7L1"],
			defensecurl: ["7L1"],
			dig: ["7M"],
			drillrun: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			iceshard: ["7L1"],
			irontail: ["7M"],
			poisonjab: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			scratch: ["7L1"],
			seismictoss: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			toxic: ["7M"],
			xscissor: ["7M"],
		},
	},
	nidoranf: {
		learnset: {
			bite: ["7L12"],
			blizzard: ["7M"],
			crunch: ["7L24"],
			dig: ["7M"],
			doublekick: ["7L9"],
			facade: ["7M"],
			furyswipes: ["7L21"],
			growl: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M", "7L15"],
			icebeam: ["7M"],
			irontail: ["7M"],
			poisonjab: ["7M"],
			poisonsting: ["7L6"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			scratch: ["7L1"],
			sludgebomb: ["7M"],
			substitute: ["7M"],
			superfang: ["7L27"],
			tailwhip: ["7L3"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M", "7L18"],
		},
	},
	nidorina: {
		learnset: {
			bite: ["7L12"],
			blizzard: ["7M"],
			crunch: ["7L39"],
			dig: ["7M"],
			doublekick: ["7L9"],
			facade: ["7M"],
			furyswipes: ["7L31"],
			growl: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M", "7L15"],
			icebeam: ["7M"],
			irontail: ["7M"],
			poisonjab: ["7M"],
			poisonsting: ["7L6", "7L1"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			scratch: ["7L1"],
			sludgebomb: ["7M"],
			substitute: ["7M"],
			superfang: ["7L47"],
			tailwhip: ["7L3", "7L1"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M", "7L23"],
		},
	},
	nidoqueen: {
		learnset: {
			blizzard: ["7M"],
			bodyslam: ["7L1", "7L0"],
			brickbreak: ["7M"],
			counter: ["7L1"],
			dig: ["7M"],
			dragonpulse: ["7M"],
			dragontail: ["7M"],
			drillrun: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			growl: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			outrage: ["7M"],
			payday: ["7M"],
			poisonjab: ["7M"],
			poisonsting: ["7L1"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			scratch: ["7L1"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			sludgebomb: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			superpower: ["7M", "7L55"],
			supersonic: ["7L1"],
			surf: ["7M"],
			tailwhip: ["7L1"],
			taunt: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	nidoranm: {
		learnset: {
			blizzard: ["7M"],
			dig: ["7M"],
			doublekick: ["7L9"],
			drillrun: ["7M"],
			facade: ["7M"],
			focusenergy: ["7L3"],
			furyattack: ["7L21"],
			headbutt: ["7M"],
			helpinghand: ["7M", "7L15"],
			hornattack: ["7L12"],
			horndrill: ["7L27"],
			icebeam: ["7M"],
			irontail: ["7M"],
			leer: ["7L1"],
			peck: ["7L1"],
			poisonjab: ["7M", "7L24"],
			poisonsting: ["7L6"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			sludgebomb: ["7M"],
			substitute: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M", "7L18"],
		},
	},
	nidorino: {
		learnset: {
			blizzard: ["7M"],
			dig: ["7M"],
			doublekick: ["7L9"],
			drillrun: ["7M"],
			facade: ["7M"],
			focusenergy: ["7L3", "7L1"],
			furyattack: ["7L31"],
			headbutt: ["7M"],
			helpinghand: ["7M", "7L15"],
			hornattack: ["7L12"],
			horndrill: ["7L47"],
			icebeam: ["7M"],
			irontail: ["7M"],
			leer: ["7L1"],
			peck: ["7L1"],
			poisonjab: ["7M", "7L39"],
			poisonsting: ["7L6", "7L1"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			sludgebomb: ["7M"],
			substitute: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M", "7L23"],
		},
	},
	nidoking: {
		learnset: {
			blizzard: ["7M"],
			brickbreak: ["7M"],
			counter: ["7L1"],
			dig: ["7M"],
			dragonpulse: ["7M"],
			dragontail: ["7M"],
			drillrun: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			focusenergy: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			leer: ["7L1"],
			megahorn: ["7M", "7L55"],
			outrage: ["7M"],
			payday: ["7M"],
			peck: ["7L1"],
			poisonjab: ["7M"],
			poisonsting: ["7L1"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			sludgebomb: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			superpower: ["7M"],
			supersonic: ["7L1"],
			surf: ["7M"],
			taunt: ["7M"],
			thrash: ["7L1", "7L0"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	clefairy: {
		learnset: {
			amnesia: ["7L16"],
			blizzard: ["7M"],
			bodyslam: ["7L24"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			dazzlinggleam: ["7M"],
			defensecurl: ["7L4"],
			dig: ["7M"],
			doubleslap: ["7L12"],
			dreameater: ["7M"],
			encore: ["7L22"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			growl: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M"],
			metronome: ["7L18"],
			minimize: ["7L10"],
			moonblast: ["7L28"],
			playrough: ["7M"],
			pound: ["7L1"],
			protect: ["7M"],
			psychic: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			sing: ["7L6"],
			solarbeam: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			teleport: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
		},
	},
	clefable: {
		learnset: {
			blizzard: ["7M"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			dazzlinggleam: ["7M"],
			defensecurl: ["7L1"],
			dig: ["7M"],
			dreameater: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			growl: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M"],
			metronome: ["7L1", "7L0"],
			playrough: ["7M"],
			pound: ["7L1"],
			protect: ["7M"],
			psychic: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			sing: ["7L1"],
			solarbeam: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			teleport: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
		},
	},
	vulpix: {
		learnset: {
			confuseray: ["7L14"],
			darkpulse: ["7M"],
			dig: ["7M"],
			ember: ["7L7"],
			facade: ["7M"],
			fireblast: ["7M", "7L31"],
			firespin: ["7L21"],
			flamethrower: ["7M", "7L24"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			irontail: ["7M"],
			protect: ["7M"],
			quickattack: ["7L10"],
			reflect: ["7M"],
			rest: ["7M"],
			roar: ["7L28"],
			substitute: ["7M"],
			tackle: ["7L1"],
			tailwhip: ["7L3"],
			toxic: ["7M"],
			willowisp: ["7M", "7L17"],
		},
	},
	vulpixalola: {
		learnset: {
			aurorabeam: ["7L17"],
			blizzard: ["7M", "7L31"],
			confuseray: ["7L14"],
			darkpulse: ["7M"],
			dazzlinggleam: ["7M", "7L21"],
			dig: ["7M"],
			facade: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			icebeam: ["7M", "7L24"],
			iceshard: ["7L10"],
			irontail: ["7M"],
			mist: ["7L7"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			roar: ["7L28"],
			substitute: ["7M"],
			tackle: ["7L1"],
			tailwhip: ["7L3"],
			toxic: ["7M"],
		},
	},
	ninetales: {
		learnset: {
			calmmind: ["7M"],
			darkpulse: ["7M"],
			dig: ["7M"],
			dreameater: ["7M"],
			ember: ["7L1"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			hypnosis: ["7L1"],
			irontail: ["7M"],
			nastyplot: ["7L1"],
			protect: ["7M"],
			quickattack: ["7L1"],
			reflect: ["7M"],
			rest: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			tackle: ["7L1"],
			tailwhip: ["7L1"],
			toxic: ["7M"],
			willowisp: ["7M"],
		},
	},
	ninetalesalola: {
		learnset: {
			blizzard: ["7M"],
			calmmind: ["7M"],
			darkpulse: ["7M"],
			dazzlinggleam: ["7M"],
			dig: ["7M"],
			dreameater: ["7M"],
			facade: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			hypnosis: ["7L1"],
			icebeam: ["7M"],
			iceshard: ["7L1"],
			irontail: ["7M"],
			mist: ["7L1"],
			nastyplot: ["7L1"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			substitute: ["7M"],
			tackle: ["7L1"],
			tailwhip: ["7L1"],
			toxic: ["7M"],
		},
	},
	jigglypuff: {
		learnset: {
			bide: ["7L10"],
			blizzard: ["7M"],
			bodyslam: ["7L22"],
			brickbreak: ["7M"],
			dazzlinggleam: ["7M"],
			defensecurl: ["7L6"],
			dig: ["7M"],
			disable: ["7L16"],
			doubleedge: ["7L28"],
			doubleslap: ["7L12"],
			dreameater: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			lightscreen: ["7M"],
			mimic: ["7L24"],
			playrough: ["7M"],
			pound: ["7L4"],
			protect: ["7M"],
			psychic: ["7M"],
			reflect: ["7M"],
			rest: ["7M", "7L18"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			sing: ["7L1"],
			solarbeam: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			teleport: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
		},
	},
	wigglytuff: {
		learnset: {
			bide: ["7L1"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			dazzlinggleam: ["7M"],
			dig: ["7M"],
			dreameater: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			lightscreen: ["7M"],
			minimize: ["7L1"],
			playrough: ["7M"],
			pound: ["7L1"],
			protect: ["7M"],
			psychic: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			sing: ["7L1"],
			solarbeam: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			teleport: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
		},
	},
	zubat: {
		learnset: {
			absorb: ["7L1"],
			airslash: ["7L33"],
			bite: ["7L9"],
			confuseray: ["7L17"],
			facade: ["7M"],
			fly: ["7M"],
			haze: ["7L20"],
			headbutt: ["7M"],
			leechlife: ["7L25"],
			megadrain: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			roost: ["7M"],
			shadowball: ["7M"],
			sludgebomb: ["7M"],
			substitute: ["7M"],
			supersonic: ["7L1"],
			swift: ["7L12"],
			taunt: ["7M"],
			toxic: ["7M", "7L28"],
			uturn: ["7M"],
			wingattack: ["7L4"],
		},
	},
	golbat: {
		learnset: {
			absorb: ["7L1"],
			airslash: ["7L51"],
			bite: ["7L8", "7L1"],
			confuseray: ["7L17"],
			crunch: ["7L1", "7L0"],
			facade: ["7M"],
			fly: ["7M"],
			haze: ["7L20"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			leechlife: ["7L31"],
			megadrain: ["7M"],
			protect: ["7M"],
			quickattack: ["7L1"],
			rest: ["7M"],
			roost: ["7M"],
			shadowball: ["7M"],
			sludgebomb: ["7M"],
			substitute: ["7M"],
			supersonic: ["7L1"],
			swift: ["7L12"],
			taunt: ["7M"],
			toxic: ["7M", "7L40"],
			uturn: ["7M"],
			whirlwind: ["7L1"],
			wingattack: ["7L4", "7L1"],
		},
	},
	oddish: {
		learnset: {
			absorb: ["7L1"],
			acid: ["7L8"],
			dazzlinggleam: ["7M"],
			facade: ["7M"],
			growth: ["7L4"],
			headbutt: ["7M"],
			megadrain: ["7M", "7L22"],
			moonblast: ["7L30"],
			poisonpowder: ["7L12"],
			protect: ["7M"],
			razorleaf: ["7L18"],
			reflect: ["7M"],
			rest: ["7M"],
			sleeppowder: ["7L14"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			stunspore: ["7L13"],
			substitute: ["7M"],
			toxic: ["7M", "7L26"],
		},
	},
	gloom: {
		learnset: {
			absorb: ["7L1"],
			acid: ["7L8", "7L1"],
			dazzlinggleam: ["7M"],
			facade: ["7M"],
			growth: ["7L4", "7L1"],
			headbutt: ["7M"],
			megadrain: ["7M", "7L27"],
			moonblast: ["7L45"],
			poisonpowder: ["7L12", "7L1"],
			protect: ["7M"],
			razorleaf: ["7L18"],
			reflect: ["7M"],
			rest: ["7M"],
			sleeppowder: ["7L14"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			stunspore: ["7L13"],
			substitute: ["7M"],
			toxic: ["7M", "7L36"],
		},
	},
	vileplume: {
		learnset: {
			absorb: ["7L1"],
			acid: ["7L1"],
			dazzlinggleam: ["7M"],
			facade: ["7M"],
			growth: ["7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			megadrain: ["7M"],
			petaldance: ["7L54"],
			poisonpowder: ["7L1"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			sludgebomb: ["7M"],
			solarbeam: ["7M", "7L1"],
			substitute: ["7M"],
			toxic: ["7M"],
		},
	},
	paras: {
		learnset: {
			absorb: ["7L9"],
			brickbreak: ["7M"],
			dig: ["7M"],
			facade: ["7M"],
			furyswipes: ["7L15"],
			growth: ["7L12"],
			headbutt: ["7M"],
			leechlife: ["7L23"],
			lightscreen: ["7M"],
			megadrain: ["7M"],
			poisonpowder: ["7L6"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			scratch: ["7L1"],
			slash: ["7L19"],
			sleeppowder: ["7L2"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			spore: ["7L27"],
			stunspore: ["7L4"],
			substitute: ["7M"],
			toxic: ["7M"],
			xscissor: ["7M", "7L31"],
		},
	},
	parasect: {
		learnset: {
			absorb: ["7L9"],
			brickbreak: ["7M"],
			dig: ["7M"],
			facade: ["7M"],
			furyswipes: ["7L15"],
			growth: ["7L12"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			leechlife: ["7L23"],
			leechseed: ["7L1"],
			lightscreen: ["7M"],
			megadrain: ["7M"],
			poisonpowder: ["7L6", "7L1"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			scratch: ["7L1"],
			screech: ["7L1"],
			slash: ["7L19"],
			sleeppowder: ["7L2", "7L1"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			spore: ["7L33"],
			stunspore: ["7L4", "7L1"],
			substitute: ["7M"],
			toxic: ["7M"],
			xscissor: ["7M", "7L43"],
		},
	},
	venonat: {
		learnset: {
			confusion: ["7L12"],
			disable: ["7L4"],
			facade: ["7M"],
			headbutt: ["7M"],
			leechlife: ["7L28"],
			megadrain: ["7M"],
			poisonpowder: ["7L14"],
			protect: ["7M"],
			psybeam: ["7L20"],
			psychic: ["7M", "7L32"],
			reflect: ["7M"],
			rest: ["7M"],
			sleeppowder: ["7L24"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			stunspore: ["7L16"],
			substitute: ["7M"],
			supersonic: ["7L8"],
			tackle: ["7L1"],
			toxic: ["7M"],
		},
	},
	venomoth: {
		learnset: {
			agility: ["7L1"],
			bugbuzz: ["7L46"],
			confusion: ["7L12", "7L1"],
			disable: ["7L4", "7L1"],
			dreameater: ["7M"],
			facade: ["7M"],
			gust: ["7L1", "7L0"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			leechlife: ["7L28"],
			megadrain: ["7M"],
			poisonpowder: ["7L14"],
			protect: ["7M"],
			psybeam: ["7L20"],
			psychic: ["7M", "7L37"],
			quiverdance: ["7L55"],
			reflect: ["7M"],
			rest: ["7M"],
			roost: ["7M"],
			screech: ["7L1"],
			sleeppowder: ["7L24"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			stunspore: ["7L16"],
			substitute: ["7M"],
			supersonic: ["7L8", "7L1"],
			tackle: ["7L1"],
			teleport: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
	},
	diglett: {
		learnset: {
			agility: ["7L12"],
			dig: ["7M", "7L18"],
			earthquake: ["7M", "7L29"],
			facade: ["7M"],
			fissure: ["7L33"],
			furyswipes: ["7L15"],
			growl: ["7L8"],
			headbutt: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			sandattack: ["7L4"],
			scratch: ["7L1"],
			slash: ["7L21"],
			sludgebomb: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L25"],
			toxic: ["7M"],
		},
	},
	diglettalola: {
		learnset: {
			agility: ["7L12"],
			dig: ["7M", "7L18"],
			earthquake: ["7M", "7L29"],
			facade: ["7M"],
			fissure: ["7L33"],
			flashcannon: ["7M"],
			furyswipes: ["7L15"],
			growl: ["7L8"],
			headbutt: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			sandattack: ["7L4"],
			scratch: ["7L1"],
			slash: ["7L21"],
			sludgebomb: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L25"],
			toxic: ["7M"],
		},
	},
	dugtrio: {
		learnset: {
			agility: ["7L12", "7L1"],
			dig: ["7M", "7L18"],
			earthquake: ["7M", "7L35"],
			facade: ["7M"],
			fissure: ["7L45"],
			furyswipes: ["7L15"],
			growl: ["7L8", "7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			sandattack: ["7L4", "7L1"],
			scratch: ["7L1"],
			screech: ["7L1"],
			slash: ["7L21"],
			sludgebomb: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L25"],
			toxic: ["7M"],
			triattack: ["7M", "7L1", "7L0"],
		},
	},
	dugtrioalola: {
		learnset: {
			agility: ["7L12", "7L1"],
			dig: ["7M", "7L18"],
			earthquake: ["7M", "7L35"],
			facade: ["7M"],
			fissure: ["7L45"],
			flashcannon: ["7M"],
			furyswipes: ["7L15"],
			growl: ["7L8", "7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			sandattack: ["7L4", "7L1"],
			scratch: ["7L1"],
			screech: ["7L1"],
			slash: ["7L21"],
			sludgebomb: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L25"],
			toxic: ["7M"],
			triattack: ["7M", "7L1", "7L0"],
		},
	},
	meowth: {
		learnset: {
			bite: ["7L3", "7L1"],
			darkpulse: ["7M"],
			dig: ["7M"],
			facade: ["7M"],
			fakeout: ["7L6", "7L1"],
			feint: ["7L15"],
			foulplay: ["7M"],
			furyswipes: ["7L19"],
			growl: ["7L1"],
			headbutt: ["7M"],
			irontail: ["7M"],
			nastyplot: ["7L31"],
			payday: ["7M", "7L12"],
			playrough: ["7M", "7L35"],
			protect: ["7M"],
			rest: ["7M"],
			scratch: ["7L1"],
			screech: ["7L23"],
			shadowball: ["7M"],
			slash: ["7L27"],
			substitute: ["7M"],
			taunt: ["7M", "7L9"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
	},
	meowthalola: {
		learnset: {
			bite: ["7L3", "7L1"],
			darkpulse: ["7M"],
			dreameater: ["7M"],
			facade: ["7M"],
			fakeout: ["7L6", "7L1"],
			feint: ["7L15"],
			foulplay: ["7M"],
			furyswipes: ["7L19"],
			growl: ["7L1"],
			headbutt: ["7M"],
			irontail: ["7M"],
			nastyplot: ["7L31"],
			payday: ["7M", "7L12"],
			playrough: ["7M", "7L35"],
			protect: ["7M"],
			rest: ["7M"],
			scratch: ["7L1"],
			screech: ["7L23"],
			shadowball: ["7M"],
			slash: ["7L27"],
			substitute: ["7M"],
			taunt: ["7M", "7L9"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
	},
	persian: {
		learnset: {
			amnesia: ["7L1"],
			bite: ["7L3", "7L1"],
			darkpulse: ["7M"],
			dig: ["7M"],
			dreameater: ["7M"],
			facade: ["7M"],
			fakeout: ["7L6", "7L1", "7S0"],
			feint: ["7L15", "7S0"],
			foulplay: ["7M"],
			furyswipes: ["7L19"],
			growl: ["7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			hypnosis: ["7L1"],
			irontail: ["7M"],
			nastyplot: ["7L37"],
			payday: ["7M", "7L12", "7S0"],
			playrough: ["7M", "7L47"],
			protect: ["7M"],
			rest: ["7M"],
			scratch: ["7L1"],
			screech: ["7L23"],
			shadowball: ["7M"],
			slash: ["7L27"],
			substitute: ["7M"],
			swift: ["7L1", "7L0"],
			taunt: ["7M", "7L9", "7S0"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
		eventData: [
			{generation: 7, level: 16, shiny: 1, ivs: {hp: 30, atk: 30, def: 25, spa: 25, spd: 25, spe: 31}, moves: ["feint", "payday", "taunt", "fakeout"], pokeball: "pokeball"},
		],
	},
	persianalola: {
		learnset: {
			amnesia: ["7L1"],
			bite: ["7L3", "7L1"],
			darkpulse: ["7M"],
			dreameater: ["7M"],
			facade: ["7M"],
			fakeout: ["7L6", "7L1"],
			feint: ["7L16"],
			foulplay: ["7M"],
			furyswipes: ["7L19"],
			growl: ["7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			hypnosis: ["7L1"],
			irontail: ["7M"],
			nastyplot: ["7L37"],
			payday: ["7M", "7L12"],
			playrough: ["7M", "7L47"],
			protect: ["7M"],
			rest: ["7M"],
			scratch: ["7L1"],
			screech: ["7L23"],
			shadowball: ["7M"],
			slash: ["7L27"],
			substitute: ["7M"],
			swift: ["7L1", "7L0"],
			taunt: ["7M", "7L9"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
	},
	psyduck: {
		learnset: {
			amnesia: ["7L41"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			confusion: ["7L14"],
			dig: ["7M"],
			disable: ["7L23"],
			facade: ["7M"],
			furyswipes: ["7L18"],
			headbutt: ["7M"],
			hydropump: ["7L45"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M"],
			payday: ["7M"],
			protect: ["7M"],
			psybeam: ["7L27"],
			psychic: ["7M"],
			rest: ["7M"],
			scald: ["7M"],
			scratch: ["7L1"],
			screech: ["7L32"],
			seismictoss: ["7M"],
			substitute: ["7M"],
			surf: ["7M", "7L36"],
			tailwhip: ["7L5"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L9"],
		},
	},
	golduck: {
		learnset: {
			amnesia: ["7L53"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			confusion: ["7L14", "7L1"],
			dig: ["7M"],
			disable: ["7L23"],
			encore: ["7L1"],
			facade: ["7M"],
			furyswipes: ["7L18"],
			headbutt: ["7M"],
			hydropump: ["7L63"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M"],
			payday: ["7M"],
			protect: ["7M"],
			psybeam: ["7L27"],
			psychic: ["7M"],
			rest: ["7M"],
			scald: ["7M"],
			scratch: ["7L1"],
			screech: ["7L32"],
			seismictoss: ["7M"],
			substitute: ["7M"],
			surf: ["7M", "7L42"],
			tailwhip: ["7L5", "7L1"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L9", "7L1"],
			yawn: ["7L1"],
		},
	},
	mankey: {
		learnset: {
			brickbreak: ["7M"],
			bulkup: ["7M"],
			dig: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			firepunch: ["7M"],
			focusenergy: ["7L5"],
			furyswipes: ["7L16"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			karatechop: ["7L13"],
			leer: ["7L1"],
			lowkick: ["7L21"],
			outrage: ["7M", "7L40"],
			payday: ["7M"],
			poisonjab: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			scratch: ["7L1"],
			screech: ["7L32"],
			seismictoss: ["7M", "7L24"],
			substitute: ["7M"],
			taunt: ["7M", "7L8"],
			thrash: ["7L37"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
			uturn: ["7M", "7L29"],
		},
	},
	primeape: {
		learnset: {
			brickbreak: ["7M"],
			bulkup: ["7M"],
			counter: ["7L1"],
			dig: ["7M"],
			earthquake: ["7M"],
			encore: ["7L1"],
			facade: ["7M"],
			firepunch: ["7M"],
			focusenergy: ["7L5", "7L1"],
			furyswipes: ["7L16"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			karatechop: ["7L13"],
			leer: ["7L1"],
			lowkick: ["7L21"],
			outrage: ["7M", "7L56"],
			payday: ["7M"],
			poisonjab: ["7M"],
			protect: ["7M"],
			rage: ["7L1", "7L0"],
			rest: ["7M"],
			rockslide: ["7M"],
			scratch: ["7L1"],
			screech: ["7L40"],
			seismictoss: ["7M", "7L24"],
			substitute: ["7M"],
			taunt: ["7M", "7L8", "7L1"],
			thrash: ["7L49"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
			uturn: ["7M", "7L33"],
		},
	},
	growlithe: {
		learnset: {
			agility: ["7L21"],
			bite: ["7L1"],
			crunch: ["7L28"],
			dig: ["7M"],
			ember: ["7L3"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M", "7L17"],
			flareblitz: ["7L38"],
			headbutt: ["7M"],
			heatwave: ["7L24"],
			helpinghand: ["7M", "7L10"],
			irontail: ["7M"],
			leer: ["7L7"],
			outrage: ["7M", "7L31"],
			playrough: ["7M", "7L35"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			roar: ["7L1"],
			substitute: ["7M"],
			takedown: ["7L14"],
			toxic: ["7M"],
			willowisp: ["7M"],
		},
	},
	arcanine: {
		learnset: {
			bite: ["7L1"],
			dig: ["7M"],
			doubleedge: ["7L1", "7S0"],
			dragonpulse: ["7M"],
			ember: ["7L1", "7S0"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			irontail: ["7M"],
			leer: ["7L1", "7S0"],
			outrage: ["7M"],
			playrough: ["7M"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			roar: ["7L1", "7S0"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			superpower: ["7M"],
			teleport: ["7M"],
			toxic: ["7M"],
			willowisp: ["7M"],
		},
		eventData: [
			{generation: 7, level: 16, shiny: 1, ivs: {hp: 25, atk: 30, def: 25, spa: 30, spd: 25, spe: 31}, moves: ["roar", "leer", "ember", "doubleedge"], pokeball: "pokeball"},
		],
	},
	poliwag: {
		learnset: {
			blizzard: ["7M"],
			bodyslam: ["7L31"],
			bubble: ["7L1"],
			bubblebeam: ["7L21"],
			dig: ["7M"],
			doubleslap: ["7L16"],
			facade: ["7M"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hydropump: ["7L36"],
			hypnosis: ["7L8"],
			icebeam: ["7M"],
			lowkick: ["7L26"],
			pound: ["7L4"],
			protect: ["7M"],
			psychic: ["7M"],
			rest: ["7M"],
			scald: ["7M"],
			substitute: ["7M"],
			surf: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L12"],
		},
	},
	poliwhirl: {
		learnset: {
			blizzard: ["7M"],
			bodyslam: ["7L39"],
			brickbreak: ["7M"],
			bubble: ["7L1"],
			bubblebeam: ["7L21"],
			dig: ["7M"],
			doubleslap: ["7L16"],
			earthquake: ["7M"],
			facade: ["7M"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hydropump: ["7L48"],
			hypnosis: ["7L8", "7L1"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			lowkick: ["7L30"],
			pound: ["7L4", "7L1"],
			protect: ["7M"],
			psychic: ["7M"],
			rest: ["7M"],
			scald: ["7M"],
			seismictoss: ["7M"],
			substitute: ["7M"],
			surf: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L12", "7L1"],
		},
	},
	poliwrath: {
		learnset: {
			blizzard: ["7M"],
			brickbreak: ["7M"],
			bubble: ["7L1"],
			bulkup: ["7M", "7L1"],
			dig: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			haze: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			hypnosis: ["7L1"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			mist: ["7L1"],
			poisonjab: ["7M"],
			pound: ["7L1"],
			protect: ["7M"],
			psychic: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			scald: ["7M"],
			seismictoss: ["7M"],
			submission: ["7L1", "7L0"],
			substitute: ["7M"],
			superpower: ["7M", "7L57"],
			surf: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L1"],
		},
	},
	abra: {
		learnset: {
			calmmind: ["7M"],
			dazzlinggleam: ["7M"],
			dreameater: ["7M"],
			facade: ["7M"],
			firepunch: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M"],
			protect: ["7M"],
			psychic: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			substitute: ["7M"],
			taunt: ["7M"],
			teleport: ["7M", "7L1"],
			thunderpunch: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
		},
	},
	kadabra: {
		learnset: {
			calmmind: ["7M"],
			confusion: ["7L1"],
			dazzlinggleam: ["7M"],
			dig: ["7M"],
			disable: ["7L6", "7L1"],
			dreameater: ["7M"],
			facade: ["7M"],
			firepunch: ["7M"],
			flash: ["7L13", "7L1"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			kinesis: ["7L1", "7L0"],
			lightscreen: ["7M"],
			nightshade: ["7L19"],
			protect: ["7M"],
			psybeam: ["7L1", "7L0"],
			psychic: ["7M", "7L45"],
			recover: ["7L39"],
			reflect: ["7M", "7L32"],
			rest: ["7M"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			substitute: ["7M", "7L26"],
			taunt: ["7M"],
			teleport: ["7M", "7L1"],
			thunderpunch: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
		},
	},
	alakazam: {
		learnset: {
			barrier: ["7L1"],
			calmmind: ["7M", "7L1", "7L0"],
			confusion: ["7L1"],
			dazzlinggleam: ["7M"],
			dig: ["7M"],
			disable: ["7L6", "7L1"],
			dreameater: ["7M"],
			encore: ["7L1"],
			facade: ["7M"],
			firepunch: ["7M"],
			flash: ["7L13", "7L1"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			kinesis: ["7L1"],
			lightscreen: ["7M"],
			nightshade: ["7L19"],
			protect: ["7M"],
			psybeam: ["7L1"],
			psychic: ["7M", "7L45"],
			recover: ["7L39"],
			reflect: ["7M", "7L32"],
			rest: ["7M"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			substitute: ["7M", "7L26"],
			taunt: ["7M"],
			teleport: ["7M", "7L1"],
			thunderpunch: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
		},
	},
	machop: {
		learnset: {
			bide: ["7L8"],
			brickbreak: ["7M", "7L21"],
			bulkup: ["7M", "7L31"],
			dig: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			focusenergy: ["7L4"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			icepunch: ["7M"],
			karatechop: ["7L16"],
			leer: ["7L1"],
			lightscreen: ["7M"],
			lowkick: ["7L1"],
			poisonjab: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			seismictoss: ["7M", "7L12"],
			submission: ["7L26"],
			substitute: ["7M"],
			superpower: ["7M", "7L36"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	machoke: {
		learnset: {
			bide: ["7L8", "7L1"],
			brickbreak: ["7M", "7L21"],
			bulkup: ["7M", "7L37"],
			dig: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			focusenergy: ["7L4", "7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			icepunch: ["7M"],
			karatechop: ["7L16"],
			leer: ["7L1"],
			lightscreen: ["7M"],
			lowkick: ["7L1"],
			poisonjab: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			seismictoss: ["7M", "7L12"],
			submission: ["7L26"],
			substitute: ["7M"],
			superpower: ["7M", "7L48"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	machamp: {
		learnset: {
			bide: ["7L8", "7L1"],
			brickbreak: ["7M", "7L21"],
			bulkup: ["7M", "7L37"],
			counter: ["7L1"],
			dig: ["7M"],
			earthquake: ["7M"],
			encore: ["7L1"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			focusenergy: ["7L4", "7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icepunch: ["7M"],
			karatechop: ["7L16"],
			leer: ["7L1"],
			lightscreen: ["7M"],
			lowkick: ["7L1"],
			poisonjab: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			seismictoss: ["7M", "7L12"],
			strength: ["7L1", "7L0"],
			submission: ["7L26"],
			substitute: ["7M"],
			superpower: ["7M", "7L48"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	bellsprout: {
		learnset: {
			acid: ["7L12"],
			facade: ["7M"],
			growth: ["7L4"],
			headbutt: ["7M"],
			megadrain: ["7M"],
			poisonjab: ["7M", "7L26"],
			poisonpowder: ["7L17"],
			protect: ["7M"],
			razorleaf: ["7L22"],
			reflect: ["7M"],
			rest: ["7M"],
			slam: ["7L30"],
			sleeppowder: ["7L16"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			stunspore: ["7L18"],
			substitute: ["7M"],
			toxic: ["7M"],
			vinewhip: ["7L1"],
			wrap: ["7L8"],
		},
	},
	weepinbell: {
		learnset: {
			acid: ["7L12", "7L1"],
			facade: ["7M"],
			growth: ["7L4", "7L1"],
			headbutt: ["7M"],
			megadrain: ["7M"],
			poisonjab: ["7M", "7L36"],
			poisonpowder: ["7L17"],
			protect: ["7M"],
			razorleaf: ["7L27"],
			reflect: ["7M"],
			rest: ["7M"],
			slam: ["7L45"],
			sleeppowder: ["7L16"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			stunspore: ["7L18"],
			substitute: ["7M"],
			toxic: ["7M"],
			vinewhip: ["7L1"],
			wrap: ["7L8", "7L1"],
		},
	},
	victreebel: {
		learnset: {
			acid: ["7L1"],
			clearsmog: ["7L1"],
			facade: ["7M"],
			growth: ["7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			leechlife: ["7L1"],
			megadrain: ["7M"],
			poisonjab: ["7M"],
			powerwhip: ["7L54", "7L1"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L1"],
			swordsdance: ["7L1"],
			toxic: ["7M"],
			vinewhip: ["7L1"],
			wrap: ["7L1"],
		},
	},
	tentacool: {
		learnset: {
			acid: ["7L13"],
			barrier: ["7L31"],
			blizzard: ["7M"],
			bubblebeam: ["7L18"],
			constrict: ["7L4"],
			dazzlinggleam: ["7M"],
			facade: ["7M"],
			headbutt: ["7M"],
			hydropump: ["7L45"],
			icebeam: ["7M"],
			megadrain: ["7M"],
			poisonjab: ["7M", "7L36"],
			poisonsting: ["7L1"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			scald: ["7M"],
			screech: ["7L40"],
			sludgebomb: ["7M"],
			substitute: ["7M"],
			supersonic: ["7L9"],
			surf: ["7M", "7L27"],
			toxic: ["7M"],
			waterfall: ["7M"],
			wrap: ["7L22"],
		},
	},
	tentacruel: {
		learnset: {
			acid: ["7L13", "7L1"],
			barrier: ["7L36"],
			blizzard: ["7M"],
			bubblebeam: ["7L18"],
			constrict: ["7L4", "7L1"],
			dazzlinggleam: ["7M"],
			facade: ["7M"],
			haze: ["7L1"],
			headbutt: ["7M"],
			hydropump: ["7L65"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			megadrain: ["7M"],
			mirrorcoat: ["7L1"],
			poisonjab: ["7M", "7L46"],
			poisonsting: ["7L1"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			scald: ["7M"],
			screech: ["7L55"],
			sludgebomb: ["7M"],
			substitute: ["7M"],
			supersonic: ["7L9", "7L1"],
			surf: ["7M", "7L27"],
			toxic: ["7M"],
			waterfall: ["7M"],
			wrap: ["7L22"],
		},
	},
	geodude: {
		learnset: {
			bide: ["7L6"],
			brickbreak: ["7M"],
			defensecurl: ["7L1"],
			dig: ["7M"],
			doubleedge: ["7L31"],
			earthquake: ["7M", "7L27"],
			explosion: ["7L35"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M", "7L23"],
			rockthrow: ["7L9"],
			sandattack: ["7L3"],
			seismictoss: ["7M"],
			selfdestruct: ["7M", "7L19"],
			stealthrock: ["7M", "7L12"],
			substitute: ["7M"],
			superpower: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L15"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	geodudealola: {
		learnset: {
			bide: ["7L6"],
			brickbreak: ["7M"],
			defensecurl: ["7L1"],
			dig: ["7M"],
			doubleedge: ["7L31"],
			earthquake: ["7M"],
			explosion: ["7L35"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M", "7L23"],
			rockthrow: ["7L9"],
			seismictoss: ["7M"],
			selfdestruct: ["7M", "7L19"],
			stealthrock: ["7M", "7L12"],
			substitute: ["7M"],
			superpower: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L15"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M", "7L27"],
			thundershock: ["7L3"],
			thunderwave: ["7M"],
			toxic: ["7M"],
		},
	},
	graveler: {
		learnset: {
			bide: ["7L6", "7L1"],
			brickbreak: ["7M"],
			defensecurl: ["7L1"],
			dig: ["7M"],
			doubleedge: ["7L39"],
			earthquake: ["7M", "7L31"],
			explosion: ["7L47"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M", "7L23"],
			rockthrow: ["7L9"],
			sandattack: ["7L3", "7L1"],
			seismictoss: ["7M"],
			selfdestruct: ["7M", "7L19"],
			stealthrock: ["7M", "7L12"],
			substitute: ["7M"],
			superpower: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L15"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	graveleralola: {
		learnset: {
			bide: ["7L6", "7L1"],
			brickbreak: ["7M"],
			defensecurl: ["7L1"],
			dig: ["7M"],
			doubleedge: ["7L39"],
			earthquake: ["7M"],
			explosion: ["7L47"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M", "7L23"],
			rockthrow: ["7L9"],
			seismictoss: ["7M"],
			selfdestruct: ["7M", "7L19"],
			stealthrock: ["7M", "7L12"],
			substitute: ["7M"],
			superpower: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L15"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M", "7L31"],
			thundershock: ["7L3", "7L1"],
			thunderwave: ["7M"],
			toxic: ["7M"],
		},
	},
	golem: {
		learnset: {
			bide: ["7L6", "7L1"],
			brickbreak: ["7M"],
			defensecurl: ["7L1"],
			dig: ["7M"],
			doubleedge: ["7L39"],
			earthquake: ["7M", "7L31"],
			explosion: ["7L47"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			megapunch: ["7L1"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M", "7L23"],
			rockthrow: ["7L9"],
			sandattack: ["7L3", "7L1"],
			seismictoss: ["7M"],
			selfdestruct: ["7M", "7L19"],
			stealthrock: ["7M", "7L12"],
			substitute: ["7M"],
			superpower: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L15"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	golemalola: {
		learnset: {
			bide: ["7L6", "7L1"],
			brickbreak: ["7M"],
			defensecurl: ["7L1"],
			dig: ["7M"],
			doubleedge: ["7L39"],
			earthquake: ["7M"],
			explosion: ["7L47"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			megapunch: ["7L1"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M", "7L23"],
			rockthrow: ["7L9"],
			seismictoss: ["7M"],
			selfdestruct: ["7M", "7L19"],
			stealthrock: ["7M", "7L12"],
			substitute: ["7M"],
			superpower: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L15"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M", "7L31"],
			thundershock: ["7L3", "7L1"],
			thunderwave: ["7M"],
			toxic: ["7M"],
		},
	},
	ponyta: {
		learnset: {
			agility: ["7L32"],
			doublekick: ["7L15"],
			ember: ["7L5"],
			facade: ["7M"],
			fireblast: ["7M", "7L38"],
			firespin: ["7L26"],
			flamethrower: ["7M"],
			flareblitz: ["7L51"],
			growl: ["7L1"],
			headbutt: ["7M"],
			irontail: ["7M"],
			protect: ["7M"],
			quickattack: ["7L10"],
			reflect: ["7M"],
			rest: ["7M"],
			solarbeam: ["7M"],
			stomp: ["7L20"],
			substitute: ["7M"],
			tackle: ["7L1"],
			tailwhip: ["7L1"],
			takedown: ["7L44"],
			toxic: ["7M"],
			willowisp: ["7M"],
		},
	},
	rapidash: {
		learnset: {
			agility: ["7L32"],
			doublekick: ["7L15"],
			drillrun: ["7M"],
			ember: ["7L5", "7L1"],
			facade: ["7M"],
			fireblast: ["7M", "7L38"],
			firespin: ["7L26"],
			flamethrower: ["7M"],
			flareblitz: ["7L65"],
			furyattack: ["7L1", "7L0"],
			growl: ["7L1"],
			headbutt: ["7M"],
			horndrill: ["7L1"],
			hyperbeam: ["7M"],
			hypnosis: ["7L1"],
			irontail: ["7M"],
			megahorn: ["7M", "7L1"],
			poisonjab: ["7M", "7L1"],
			protect: ["7M"],
			quickattack: ["7L10"],
			reflect: ["7M"],
			rest: ["7M"],
			solarbeam: ["7M"],
			stomp: ["7L20"],
			substitute: ["7M"],
			tackle: ["7L1"],
			tailwhip: ["7L1"],
			takedown: ["7L51"],
			toxic: ["7M"],
			willowisp: ["7M"],
		},
	},
	slowpoke: {
		learnset: {
			amnesia: ["7L48"],
			blizzard: ["7M"],
			calmmind: ["7M"],
			confusion: ["7L18"],
			dig: ["7M"],
			disable: ["7L24"],
			dreameater: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			growl: ["7L6"],
			headbutt: ["7M"],
			icebeam: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M"],
			payday: ["7M"],
			protect: ["7M"],
			psychic: ["7M", "7L42"],
			reflect: ["7M"],
			rest: ["7M", "7L30"],
			scald: ["7M"],
			shadowball: ["7M"],
			substitute: ["7M"],
			surf: ["7M", "7L36"],
			tackle: ["7L1"],
			teleport: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
			watergun: ["7L12"],
			yawn: ["7L1"],
		},
	},
	slowbro: {
		learnset: {
			amnesia: ["7L62"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			confusion: ["7L18"],
			dig: ["7M"],
			disable: ["7L24"],
			dreameater: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			foulplay: ["7M"],
			growl: ["7L6", "7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M"],
			payday: ["7M"],
			protect: ["7M"],
			psychic: ["7M", "7L49"],
			reflect: ["7M"],
			rest: ["7M", "7L30"],
			scald: ["7M"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			stomp: ["7L1"],
			substitute: ["7M"],
			surf: ["7M", "7L36"],
			tackle: ["7L1"],
			teleport: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
			watergun: ["7L12", "7L1"],
			withdraw: ["7L1", "7L0"],
			yawn: ["7L1"],
		},
	},
	magnemite: {
		learnset: {
			facade: ["7M"],
			flashcannon: ["7M", "7L38"],
			headbutt: ["7M"],
			lightscreen: ["7M", "7L20"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			screech: ["7L32"],
			sonicboom: ["7L15"],
			substitute: ["7M"],
			supersonic: ["7L1"],
			tackle: ["7L1"],
			teleport: ["7M"],
			thunder: ["7M", "7L44"],
			thunderbolt: ["7M", "7L26"],
			thundershock: ["7L5"],
			thunderwave: ["7M", "7L10"],
			toxic: ["7M"],
		},
	},
	magneton: {
		learnset: {
			facade: ["7M"],
			flashcannon: ["7M", "7L46"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			lightscreen: ["7M", "7L20"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			screech: ["7L36"],
			sonicboom: ["7L15"],
			substitute: ["7M"],
			supersonic: ["7L1"],
			tackle: ["7L1"],
			teleport: ["7M"],
			thunder: ["7M", "7L56"],
			thunderbolt: ["7M", "7L26"],
			thundershock: ["7L5", "7L1"],
			thunderwave: ["7M", "7L10", "7L1"],
			toxic: ["7M"],
			triattack: ["7M", "7L1", "7L0"],
		},
	},
	farfetchd: {
		learnset: {
			agility: ["7L22"],
			airslash: ["7L31"],
			cut: ["7L9"],
			facade: ["7M"],
			feint: ["7L1"],
			fly: ["7M"],
			focusenergy: ["7L4"],
			furyattack: ["7L18"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			irontail: ["7M"],
			leer: ["7L1"],
			mirrormove: ["7L1"],
			peck: ["7L1"],
			poisonjab: ["7M", "7L1"],
			protect: ["7M"],
			quickattack: ["7L1"],
			razorleaf: ["7L13"],
			reflect: ["7M"],
			rest: ["7M"],
			roost: ["7M"],
			sandattack: ["7L1"],
			skyattack: ["7L40"],
			slash: ["7L27"],
			substitute: ["7M"],
			swordsdance: ["7L36"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
	},
	doduo: {
		learnset: {
			agility: ["7L22"],
			drillpeck: ["7L27"],
			facade: ["7M"],
			fly: ["7M"],
			furyattack: ["7L16"],
			growl: ["7L1"],
			headbutt: ["7M"],
			jumpkick: ["7L38"],
			peck: ["7L1"],
			protect: ["7M"],
			quickattack: ["7L5"],
			rage: ["7L10"],
			reflect: ["7M"],
			rest: ["7M"],
			roost: ["7M"],
			substitute: ["7M"],
			swordsdance: ["7L32"],
			thrash: ["7L44"],
			toxic: ["7M"],
		},
	},
	dodrio: {
		learnset: {
			agility: ["7L22"],
			drillpeck: ["7L27"],
			facade: ["7M"],
			fly: ["7M"],
			furyattack: ["7L16"],
			growl: ["7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			jumpkick: ["7L48"],
			mirrormove: ["7L1"],
			peck: ["7L1"],
			protect: ["7M"],
			quickattack: ["7L5", "7L1"],
			rage: ["7L10", "7L1"],
			reflect: ["7M"],
			rest: ["7M"],
			roost: ["7M"],
			substitute: ["7M"],
			supersonic: ["7L1"],
			swordsdance: ["7L37"],
			taunt: ["7M"],
			thrash: ["7L59"],
			toxic: ["7M"],
			triattack: ["7M", "7L1", "7L0"],
		},
	},
	seel: {
		learnset: {
			aquajet: ["7L12"],
			aurorabeam: ["7L26"],
			blizzard: ["7M"],
			doubleedge: ["7L50"],
			drillrun: ["7M"],
			encore: ["7L8"],
			facade: ["7M"],
			growl: ["7L4"],
			headbutt: ["7M", "7L1"],
			helpinghand: ["7M"],
			icebeam: ["7M", "7L44"],
			iceshard: ["7L16"],
			irontail: ["7M"],
			megahorn: ["7M"],
			payday: ["7M"],
			protect: ["7M"],
			rest: ["7M", "7L20"],
			substitute: ["7M"],
			surf: ["7M"],
			takedown: ["7L38"],
			toxic: ["7M"],
			waterfall: ["7M", "7L32"],
		},
	},
	dewgong: {
		learnset: {
			aquajet: ["7L12", "7L1"],
			aurorabeam: ["7L26"],
			blizzard: ["7M"],
			doubleedge: ["7L62"],
			drillrun: ["7M"],
			encore: ["7L8", "7L1"],
			facade: ["7M"],
			fakeout: ["7L1"],
			growl: ["7L4", "7L1"],
			headbutt: ["7M", "7L1"],
			helpinghand: ["7M"],
			horndrill: ["7L1"],
			hyperbeam: ["7M"],
			icebeam: ["7M", "7L52"],
			iceshard: ["7L15"],
			irontail: ["7M"],
			megahorn: ["7M"],
			payday: ["7M"],
			protect: ["7M"],
			rest: ["7M", "7L20"],
			substitute: ["7M"],
			surf: ["7M"],
			takedown: ["7L42"],
			toxic: ["7M"],
			waterfall: ["7M", "7L32"],
		},
	},
	grimer: {
		learnset: {
			acidarmor: ["7L42"],
			dig: ["7M"],
			disable: ["7L18"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			harden: ["7L6"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			icepunch: ["7M"],
			megadrain: ["7M"],
			minimize: ["7L12"],
			poisongas: ["7L1"],
			poisonjab: ["7M"],
			pound: ["7L1"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			screech: ["7L30"],
			selfdestruct: ["7M"],
			shadowball: ["7M"],
			sludge: ["7L24"],
			sludgebomb: ["7M", "7L48"],
			substitute: ["7M"],
			taunt: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M", "7L36"],
		},
	},
	grimeralola: {
		learnset: {
			acidarmor: ["7L42"],
			bite: ["7L24"],
			crunch: ["7L36"],
			dig: ["7M"],
			disable: ["7L18"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			harden: ["7L6"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			icepunch: ["7M"],
			megadrain: ["7M"],
			minimize: ["7L12"],
			poisongas: ["7L1"],
			poisonjab: ["7M"],
			pound: ["7L1"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			screech: ["7L30"],
			selfdestruct: ["7M"],
			shadowball: ["7M"],
			sludgebomb: ["7M", "7L48"],
			substitute: ["7M"],
			taunt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	muk: {
		learnset: {
			acidarmor: ["7L48"],
			brickbreak: ["7M"],
			darkpulse: ["7M"],
			dig: ["7M"],
			disable: ["7L18"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			harden: ["7L6", "7L1"],
			haze: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icepunch: ["7M"],
			megadrain: ["7M"],
			minimize: ["7L12", "7L1"],
			moonblast: ["7L1"],
			poisongas: ["7L1"],
			poisonjab: ["7M"],
			pound: ["7L1"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			screech: ["7L30"],
			selfdestruct: ["7M"],
			shadowball: ["7M"],
			sludge: ["7L24"],
			sludgebomb: ["7M", "7L60"],
			substitute: ["7M"],
			taunt: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M", "7L36"],
		},
	},
	mukalola: {
		learnset: {
			acidarmor: ["7L48"],
			bite: ["7L24"],
			brickbreak: ["7M"],
			crunch: ["7L36"],
			darkpulse: ["7M"],
			dig: ["7M"],
			disable: ["7L18"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			foulplay: ["7M"],
			harden: ["7L6", "7L1"],
			haze: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icepunch: ["7M"],
			megadrain: ["7M"],
			minimize: ["7L12", "7L1"],
			moonblast: ["7L1"],
			poisongas: ["7L1"],
			poisonjab: ["7M"],
			pound: ["7L1"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			screech: ["7L30"],
			selfdestruct: ["7M"],
			shadowball: ["7M"],
			sludgebomb: ["7M", "7L60"],
			substitute: ["7M"],
			taunt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	shellder: {
		learnset: {
			aurorabeam: ["7L27"],
			blizzard: ["7M"],
			clamp: ["7L22"],
			facade: ["7M"],
			headbutt: ["7M"],
			hydropump: ["7L45"],
			icebeam: ["7M", "7L36"],
			iceshard: ["7L13"],
			leer: ["7L9"],
			protect: ["7M", "7L31"],
			reflect: ["7M"],
			rest: ["7M"],
			selfdestruct: ["7M"],
			shellsmash: ["7L40"],
			substitute: ["7M"],
			supersonic: ["7L18"],
			surf: ["7M"],
			tackle: ["7L1"],
			teleport: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
			watergun: ["7L1"],
			withdraw: ["7L4"],
		},
	},
	cloyster: {
		learnset: {
			barrier: ["7L1"],
			blizzard: ["7M"],
			facade: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			leer: ["7L1"],
			poisonjab: ["7M"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			selfdestruct: ["7M"],
			spikecannon: ["7L1", "7L0"],
			substitute: ["7M"],
			surf: ["7M"],
			tackle: ["7L1"],
			teleport: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
			twineedle: ["7L1"],
			watergun: ["7L1"],
			withdraw: ["7L1"],
		},
	},
	gastly: {
		learnset: {
			confuseray: ["7L5"],
			darkpulse: ["7M", "7L28"],
			dazzlinggleam: ["7M"],
			dreameater: ["7M", "7L33"],
			facade: ["7M"],
			firepunch: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			hypnosis: ["7L1"],
			icepunch: ["7M"],
			lick: ["7L1"],
			megadrain: ["7M"],
			nightshade: ["7L12"],
			poisongas: ["7L7"],
			protect: ["7M"],
			psychic: ["7M"],
			rest: ["7M"],
			selfdestruct: ["7M"],
			shadowball: ["7M", "7L26"],
			sludgebomb: ["7M"],
			smog: ["7L1"],
			substitute: ["7M"],
			suckerpunch: ["7L19"],
			taunt: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M", "7L21"],
			willowisp: ["7M", "7L14"],
		},
	},
	haunter: {
		learnset: {
			confuseray: ["7L5", "7L1"],
			darkpulse: ["7M", "7L36"],
			dazzlinggleam: ["7M"],
			dreameater: ["7M", "7L45"],
			facade: ["7M"],
			firepunch: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			hypnosis: ["7L1"],
			icepunch: ["7M"],
			lick: ["7L1"],
			megadrain: ["7M"],
			nightshade: ["7L12"],
			poisongas: ["7L7"],
			poisonjab: ["7M"],
			protect: ["7M"],
			psychic: ["7M"],
			rest: ["7M"],
			selfdestruct: ["7M"],
			shadowball: ["7M", "7L30"],
			sludgebomb: ["7M"],
			smog: ["7L1"],
			substitute: ["7M"],
			suckerpunch: ["7L19"],
			taunt: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M", "7L21"],
			willowisp: ["7M", "7L14"],
		},
	},
	gengar: {
		learnset: {
			brickbreak: ["7M"],
			confuseray: ["7L5", "7L1"],
			darkpulse: ["7M", "7L36"],
			dazzlinggleam: ["7M"],
			disable: ["7L1"],
			dreameater: ["7M", "7L45"],
			facade: ["7M"],
			firepunch: ["7M"],
			foulplay: ["7M"],
			haze: ["7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			hypnosis: ["7L1"],
			icepunch: ["7M"],
			lick: ["7L1"],
			megadrain: ["7M"],
			nightshade: ["7L12"],
			poisongas: ["7L7"],
			poisonjab: ["7M"],
			protect: ["7M"],
			psychic: ["7M"],
			rest: ["7M"],
			seismictoss: ["7M"],
			selfdestruct: ["7M"],
			shadowball: ["7M", "7L30"],
			sludgebomb: ["7M"],
			smog: ["7L1"],
			substitute: ["7M"],
			suckerpunch: ["7L19"],
			taunt: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M", "7L21"],
			willowisp: ["7M", "7L14"],
		},
	},
	onix: {
		learnset: {
			bind: ["7L1"],
			dig: ["7M", "7L20"],
			doubleedge: ["7L45"],
			dragonpulse: ["7M"],
			dragontail: ["7M"],
			earthquake: ["7M", "7L35"],
			facade: ["7M"],
			flashcannon: ["7M"],
			harden: ["7L1"],
			headbutt: ["7M"],
			irontail: ["7M", "7L40"],
			protect: ["7M"],
			rage: ["7L10"],
			rest: ["7M"],
			rockslide: ["7M", "7L30"],
			rockthrow: ["7L1"],
			screech: ["7L15"],
			selfdestruct: ["7M"],
			slam: ["7L25"],
			stealthrock: ["7M", "7L5"],
			substitute: ["7M"],
			tackle: ["7L1"],
			taunt: ["7M"],
			toxic: ["7M"],
		},
	},
	drowzee: {
		learnset: {
			brickbreak: ["7M"],
			calmmind: ["7M"],
			confusion: ["7L9"],
			dazzlinggleam: ["7M"],
			disable: ["7L4"],
			dreameater: ["7M", "7L40"],
			facade: ["7M"],
			firepunch: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M", "7L27"],
			hypnosis: ["7L1"],
			icepunch: ["7M"],
			lightscreen: ["7M"],
			meditate: ["7L18"],
			nastyplot: ["7L36"],
			poisongas: ["7L13"],
			pound: ["7L1"],
			protect: ["7M"],
			psybeam: ["7L22"],
			psychic: ["7M", "7L31"],
			reflect: ["7M"],
			rest: ["7M"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			substitute: ["7M"],
			taunt: ["7M"],
			teleport: ["7M"],
			thunderpunch: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
		},
	},
	hypno: {
		learnset: {
			barrier: ["7L1"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			confusion: ["7L9", "7L1"],
			dazzlinggleam: ["7M"],
			disable: ["7L4", "7L1"],
			dreameater: ["7M", "7L55"],
			facade: ["7M"],
			firepunch: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M", "7L27"],
			hyperbeam: ["7M"],
			hypnosis: ["7L1"],
			icepunch: ["7M"],
			lightscreen: ["7M"],
			meditate: ["7L18"],
			nastyplot: ["7L46"],
			poisongas: ["7L13"],
			pound: ["7L1"],
			protect: ["7M"],
			psybeam: ["7L22"],
			psychic: ["7M", "7L36"],
			reflect: ["7M"],
			rest: ["7M"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			substitute: ["7M"],
			taunt: ["7M"],
			teleport: ["7M"],
			thunderpunch: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
		},
	},
	krabby: {
		learnset: {
			blizzard: ["7M"],
			brickbreak: ["7M"],
			bubble: ["7L1"],
			bubblebeam: ["7L18"],
			crabhammer: ["7L36"],
			dig: ["7M"],
			facade: ["7M"],
			guillotine: ["7L41"],
			harden: ["7L14"],
			headbutt: ["7M"],
			icebeam: ["7M"],
			leer: ["7L9"],
			protect: ["7M", "7L27"],
			rest: ["7M"],
			rockslide: ["7M"],
			scald: ["7M"],
			slam: ["7L32"],
			stomp: ["7L23"],
			substitute: ["7M"],
			superpower: ["7M"],
			surf: ["7M"],
			toxic: ["7M"],
			visegrip: ["7L5"],
			xscissor: ["7M"],
		},
	},
	kingler: {
		learnset: {
			agility: ["7L1"],
			amnesia: ["7L1"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			bubble: ["7L1"],
			bubblebeam: ["7L18"],
			crabhammer: ["7L41"],
			dig: ["7M"],
			facade: ["7M"],
			guillotine: ["7L56"],
			harden: ["7L14", "7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			leer: ["7L9", "7L1"],
			protect: ["7M", "7L27"],
			rest: ["7M"],
			rockslide: ["7M"],
			scald: ["7M"],
			slam: ["7L37"],
			stomp: ["7L23"],
			substitute: ["7M"],
			superpower: ["7M"],
			surf: ["7M"],
			toxic: ["7M"],
			visegrip: ["7L5", "7L1"],
			xscissor: ["7M"],
		},
	},
	voltorb: {
		learnset: {
			explosion: ["7L45"],
			facade: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			lightscreen: ["7M", "7L3"],
			mirrorcoat: ["7L38", "7S0"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			screech: ["7L24"],
			selfdestruct: ["7M", "7L19", "7S0"],
			sonicboom: ["7L6"],
			substitute: ["7M"],
			swift: ["7L14", "7S0"],
			tackle: ["7L1"],
			taunt: ["7M"],
			teleport: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M", "7L31", "7S0"],
			thundershock: ["7L9"],
			thunderwave: ["7M"],
			toxic: ["7M"],
		},
		eventData: [
			{generation: 7, level: 42, shiny: 1, perfectIVs: 3, moves: ["mirrorcoat", "thunderbolt", "swift", "selfdestruct"]},
		],
	},
	electrode: {
		learnset: {
			explosion: ["7L60"],
			facade: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			lightscreen: ["7M", "7L3", "7L1"],
			mirrorcoat: ["7L48"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			screech: ["7L24", "7S0"],
			selfdestruct: ["7M", "7L19", "7S0"],
			sonicboom: ["7L6", "7L1"],
			substitute: ["7M"],
			swift: ["7L14", "7S0"],
			tackle: ["7L1"],
			taunt: ["7M"],
			teleport: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M", "7L36", "7S0"],
			thundershock: ["7L9", "7L1"],
			thunderwave: ["7M"],
			toxic: ["7M"],
		},
		eventData: [
			{generation: 7, level: 42, shiny: 1, perfectIVs: 3, moves: ["thunderbolt", "screech", "selfdestruct", "swift"]},
		],
	},
	exeggcute: {
		learnset: {
			barrage: ["7L1"],
			confusion: ["7L14"],
			dreameater: ["7M"],
			facade: ["7M"],
			headbutt: ["7M"],
			hypnosis: ["7L7"],
			leechseed: ["7L34"],
			lightscreen: ["7M"],
			megadrain: ["7M"],
			poisonpowder: ["7L18"],
			protect: ["7M"],
			psybeam: ["7L27"],
			psychic: ["7M"],
			reflect: ["7M", "7L41"],
			rest: ["7M"],
			selfdestruct: ["7M"],
			sleeppowder: ["7L20"],
			sludgebomb: ["7M"],
			solarbeam: ["7M", "7L48"],
			stunspore: ["7L16"],
			substitute: ["7M"],
			teleport: ["7M"],
			toxic: ["7M"],
		},
	},
	exeggutor: {
		learnset: {
			barrage: ["7L1"],
			confusion: ["7L1"],
			dreameater: ["7M"],
			eggbomb: ["7L1"],
			facade: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			hypnosis: ["7L1"],
			lightscreen: ["7M"],
			megadrain: ["7M"],
			powerwhip: ["7L1"],
			protect: ["7M"],
			psychic: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			selfdestruct: ["7M"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			stomp: ["7L1", "7L0"],
			stunspore: ["7L1"],
			substitute: ["7M"],
			teleport: ["7M"],
			toxic: ["7M"],
		},
	},
	exeggutoralola: {
		learnset: {
			barrage: ["7L1"],
			brickbreak: ["7M"],
			confusion: ["7L1"],
			dragonpulse: ["7M", "7L1", "7L0"],
			dragontail: ["7M"],
			dreameater: ["7M"],
			earthquake: ["7M"],
			eggbomb: ["7L1"],
			facade: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			hypnosis: ["7L1"],
			irontail: ["7M"],
			lightscreen: ["7M"],
			megadrain: ["7M"],
			outrage: ["7M"],
			powerwhip: ["7L1"],
			protect: ["7M"],
			psychic: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			selfdestruct: ["7M"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			stunspore: ["7L1"],
			substitute: ["7M"],
			superpower: ["7M"],
			teleport: ["7M"],
			toxic: ["7M"],
		},
	},
	cubone: {
		learnset: {
			blizzard: ["7M"],
			boneclub: ["7L12"],
			bonemerang: ["7L26"],
			brickbreak: ["7M"],
			dig: ["7M"],
			doubleedge: ["7L36"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			focusenergy: ["7L24"],
			growl: ["7L1"],
			headbutt: ["7M", "7L14"],
			icebeam: ["7M"],
			irontail: ["7M"],
			leer: ["7L6"],
			protect: ["7M"],
			rage: ["7L18"],
			rest: ["7M"],
			rockslide: ["7M"],
			seismictoss: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			tailwhip: ["7L2"],
			thrash: ["7L30"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	marowak: {
		learnset: {
			blizzard: ["7M"],
			boneclub: ["7L12", "7L1"],
			bonemerang: ["7L26"],
			brickbreak: ["7M"],
			dig: ["7M"],
			doubleedge: ["7L48"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			focusenergy: ["7L24"],
			growl: ["7L1"],
			headbutt: ["7M", "7L14"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			irontail: ["7M"],
			leer: ["7L6", "7L1"],
			outrage: ["7M"],
			protect: ["7M"],
			rage: ["7L18"],
			rest: ["7M"],
			rockslide: ["7M"],
			screech: ["7L1"],
			seismictoss: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			swordsdance: ["7L1", "7L0"],
			tailwhip: ["7L2", "7L1"],
			thrash: ["7L36"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	marowakalola: {
		learnset: {
			blizzard: ["7M"],
			boneclub: ["7L12", "7L1"],
			bonemerang: ["7L26"],
			brickbreak: ["7M"],
			darkpulse: ["7M"],
			dig: ["7M"],
			dreameater: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			firespin: ["7L14"],
			flamethrower: ["7M"],
			flareblitz: ["7L48"],
			growl: ["7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			irontail: ["7M"],
			leer: ["7L6", "7L1"],
			outrage: ["7M"],
			protect: ["7M"],
			rage: ["7L18"],
			rest: ["7M"],
			rockslide: ["7M"],
			screech: ["7L1"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			swordsdance: ["7L1", "7L0"],
			tailwhip: ["7L2", "7L1"],
			thrash: ["7L36"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
			willowisp: ["7M", "7L24"],
		},
	},
	hitmonlee: {
		learnset: {
			brickbreak: ["7M", "7L20", "7S0"],
			bulkup: ["7M"],
			doublekick: ["7L10"],
			earthquake: ["7M"],
			facade: ["7M", "7L25", "7S0"],
			feint: ["7L15", "7S0"],
			focusenergy: ["7L35"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			highjumpkick: ["7L45"],
			jumpkick: ["7L30", "7S0"],
			meditate: ["7L5"],
			megakick: ["7L40"],
			poisonjab: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			rollingkick: ["7L1"],
			seismictoss: ["7M"],
			substitute: ["7M"],
			superpower: ["7M"],
			toxic: ["7M"],
		},
		eventData: [
			{generation: 7, level: 30, shiny: 1, ivs: {hp: 25, atk: 30, def: 25, spa: 25, spd: 30, spe: 31}, moves: ["jumpkick", "facade", "brickbreak", "feint"], pokeball: "pokeball"},
		],
	},
	hitmonchan: {
		learnset: {
			agility: ["7L10"],
			brickbreak: ["7M"],
			bulkup: ["7M"],
			cometpunch: ["7L1"],
			counter: ["7L45"],
			dizzypunch: ["7L25", "7S0"],
			earthquake: ["7M"],
			facade: ["7M"],
			feint: ["7L15"],
			firepunch: ["7M", "7L30", "7S0"],
			focusenergy: ["7L35"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			icepunch: ["7M", "7L30", "7S0"],
			leer: ["7L5"],
			megapunch: ["7L40"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			seismictoss: ["7M"],
			substitute: ["7M"],
			swift: ["7L20"],
			thunderpunch: ["7M", "7L30", "7S0"],
			toxic: ["7M"],
		},
		eventData: [
			{generation: 7, level: 30, shiny: 1, ivs: {hp: 25, atk: 31, def: 30, spa: 25, spd: 30, spe: 25}, moves: ["firepunch", "icepunch", "thunderpunch", "dizzypunch"], pokeball: "pokeball"},
		],
	},
	lickitung: {
		learnset: {
			acid: ["7L10"],
			bind: ["7L25"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			dig: ["7M"],
			disable: ["7L20"],
			dragontail: ["7M"],
			dreameater: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			lick: ["7L1"],
			powerwhip: ["7L45"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			screech: ["7L35"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			slam: ["7L30"],
			solarbeam: ["7M"],
			stomp: ["7L15"],
			substitute: ["7M"],
			surf: ["7M"],
			thrash: ["7L40"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
			wrap: ["7L5"],
		},
	},
	koffing: {
		learnset: {
			clearsmog: ["7L12"],
			darkpulse: ["7M"],
			explosion: ["7L48"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			haze: ["7L36"],
			headbutt: ["7M"],
			poisongas: ["7L1"],
			protect: ["7M"],
			rest: ["7M"],
			selfdestruct: ["7M", "7L24"],
			shadowball: ["7M"],
			sludge: ["7L18"],
			sludgebomb: ["7M", "7L42"],
			smog: ["7L6"],
			substitute: ["7M"],
			tackle: ["7L1"],
			taunt: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M", "7L30"],
			willowisp: ["7M"],
		},
	},
	weezing: {
		learnset: {
			clearsmog: ["7L12", "7L1"],
			darkpulse: ["7M"],
			explosion: ["7L60"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			haze: ["7L40"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			poisongas: ["7L1"],
			protect: ["7M"],
			psybeam: ["7L1"],
			rest: ["7M"],
			screech: ["7L1"],
			selfdestruct: ["7M", "7L24"],
			shadowball: ["7M"],
			sludge: ["7L18"],
			sludgebomb: ["7M", "7L50"],
			smog: ["7L6", "7L1"],
			substitute: ["7M"],
			tackle: ["7L1"],
			taunt: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M", "7L30"],
			willowisp: ["7M"],
		},
	},
	rhyhorn: {
		learnset: {
			blizzard: ["7M"],
			dig: ["7M"],
			dragonpulse: ["7M"],
			drillrun: ["7M", "7L24"],
			earthquake: ["7M", "7L48"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			furyattack: ["7L7"],
			headbutt: ["7M"],
			hornattack: ["7L1"],
			horndrill: ["7L55"],
			icebeam: ["7M"],
			irontail: ["7M"],
			megahorn: ["7M", "7L36"],
			poisonjab: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M", "7L43"],
			rockthrow: ["7L19"],
			sandattack: ["7L1"],
			stealthrock: ["7M"],
			stomp: ["7L12"],
			substitute: ["7M"],
			superpower: ["7M"],
			tailwhip: ["7L1"],
			takedown: ["7L31"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M"],
		},
	},
	rhydon: {
		learnset: {
			blizzard: ["7M"],
			brickbreak: ["7M"],
			counter: ["7L1"],
			crunch: ["7L1"],
			dig: ["7M"],
			dragonpulse: ["7M"],
			dragontail: ["7M"],
			drillrun: ["7M", "7L24"],
			earthquake: ["7M", "7L54"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			furyattack: ["7L7", "7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hornattack: ["7L1"],
			horndrill: ["7L67"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			megahorn: ["7M", "7L36"],
			outrage: ["7M"],
			payday: ["7M"],
			poisonjab: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M", "7L48"],
			rockthrow: ["7L19"],
			sandattack: ["7L1"],
			seismictoss: ["7M"],
			stealthrock: ["7M"],
			stomp: ["7L12"],
			substitute: ["7M"],
			superpower: ["7M"],
			surf: ["7M"],
			tailwhip: ["7L1"],
			takedown: ["7L31"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	chansey: {
		learnset: {
			blizzard: ["7M"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			celebrate: ["7S0"],
			dazzlinggleam: ["7M"],
			defensecurl: ["7L4"],
			doubleedge: ["7L45"],
			doubleslap: ["7L12"],
			dreameater: ["7M"],
			earthquake: ["7M"],
			eggbomb: ["7L35"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			growl: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M", "7L40"],
			minimize: ["7L20"],
			pound: ["7L1", "7S0"],
			protect: ["7M"],
			psychic: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			sing: ["7L30"],
			softboiled: ["7L16"],
			solarbeam: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			tailwhip: ["7L8"],
			takedown: ["7L25"],
			teleport: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
		},
		eventData: [
			{generation: 7, level: 1, gender: "F", nature: "Mild", moves: ["celebrate", "pound"], pokeball: "cherishball"},
		],
	},
	tangela: {
		learnset: {
			absorb: ["7L1"],
			amnesia: ["7L49"],
			bind: ["7L22"],
			confusion: ["7L10"],
			constrict: ["7L1"],
			facade: ["7M"],
			growth: ["7L27"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			leechseed: ["7L39"],
			megadrain: ["7M", "7L34"],
			poisonpowder: ["7L17"],
			powerwhip: ["7L54"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			slam: ["7L44"],
			sleeppowder: ["7L5"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			stunspore: ["7L29"],
			substitute: ["7M"],
			toxic: ["7M"],
			vinewhip: ["7L15"],
		},
	},
	kangaskhan: {
		learnset: {
			bite: ["7L17"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			cometpunch: ["7L1"],
			crunch: ["7L39"],
			dig: ["7M"],
			dizzypunch: ["7L33"],
			earthquake: ["7M"],
			facade: ["7M"],
			fakeout: ["7L6"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			leer: ["7L1"],
			megapunch: ["7L28"],
			outrage: ["7M", "7L44"],
			protect: ["7M"],
			rage: ["7L22"],
			rest: ["7M"],
			rockslide: ["7M"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L50"],
			surf: ["7M"],
			tailwhip: ["7L11"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
		},
	},
	horsea: {
		learnset: {
			agility: ["7L33"],
			blizzard: ["7M"],
			bubble: ["7L1"],
			bubblebeam: ["7L18"],
			dragonpulse: ["7M", "7L36"],
			facade: ["7M"],
			flashcannon: ["7M"],
			focusenergy: ["7L24"],
			headbutt: ["7M"],
			hydropump: ["7L42"],
			icebeam: ["7M"],
			leer: ["7L15"],
			outrage: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			scald: ["7M"],
			smokescreen: ["7L6"],
			substitute: ["7M"],
			surf: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M", "7L27"],
			watergun: ["7L9"],
		},
	},
	seadra: {
		learnset: {
			agility: ["7L36"],
			blizzard: ["7M"],
			bubble: ["7L1"],
			bubblebeam: ["7L18"],
			clearsmog: ["7L1"],
			disable: ["7L1"],
			dragonpulse: ["7M", "7L42"],
			facade: ["7M"],
			flashcannon: ["7M"],
			focusenergy: ["7L24"],
			headbutt: ["7M"],
			hydropump: ["7L51"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			leer: ["7L15", "7L1"],
			outrage: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			scald: ["7M"],
			smokescreen: ["7L6", "7L1"],
			substitute: ["7M"],
			surf: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M", "7L27"],
			watergun: ["7L9", "7L1"],
		},
	},
	goldeen: {
		learnset: {
			agility: ["7L30"],
			blizzard: ["7M"],
			drillrun: ["7M"],
			facade: ["7M"],
			furyattack: ["7L20"],
			headbutt: ["7M"],
			hornattack: ["7L14"],
			horndrill: ["7L34"],
			icebeam: ["7M"],
			megahorn: ["7M", "7L40"],
			peck: ["7L1"],
			poisonjab: ["7M"],
			protect: ["7M"],
			quickattack: ["7L10"],
			rest: ["7M"],
			scald: ["7M"],
			substitute: ["7M"],
			supersonic: ["7L4"],
			surf: ["7M"],
			tailwhip: ["7L1"],
			toxic: ["7M"],
			waterfall: ["7M", "7L24"],
		},
	},
	seaking: {
		learnset: {
			agility: ["7L30"],
			blizzard: ["7M"],
			drillrun: ["7M"],
			facade: ["7M"],
			furyattack: ["7L20"],
			headbutt: ["7M"],
			hornattack: ["7L14"],
			horndrill: ["7L39"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			megahorn: ["7M", "7L50"],
			peck: ["7L1"],
			poisonjab: ["7M"],
			protect: ["7M"],
			psybeam: ["7L1"],
			quickattack: ["7L10", "7L1"],
			rest: ["7M"],
			scald: ["7M"],
			skullbash: ["7L1"],
			substitute: ["7M"],
			supersonic: ["7L4", "7L1"],
			surf: ["7M"],
			tailwhip: ["7L1"],
			toxic: ["7M"],
			waterfall: ["7M", "7L24"],
		},
	},
	staryu: {
		learnset: {
			blizzard: ["7M"],
			bubblebeam: ["7L27"],
			confuseray: ["7L22"],
			dazzlinggleam: ["7M"],
			facade: ["7M"],
			flashcannon: ["7M"],
			harden: ["7L1"],
			headbutt: ["7M"],
			hydropump: ["7L45"],
			icebeam: ["7M"],
			lightscreen: ["7M", "7L31"],
			minimize: ["7L18"],
			protect: ["7M"],
			psychic: ["7M", "7L36"],
			psywave: ["7L4"],
			recover: ["7L40"],
			reflect: ["7M"],
			rest: ["7M"],
			scald: ["7M"],
			substitute: ["7M"],
			surf: ["7M"],
			swift: ["7L13"],
			tackle: ["7L1"],
			teleport: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L9"],
		},
	},
	starmie: {
		learnset: {
			blizzard: ["7M"],
			dazzlinggleam: ["7M"],
			dreameater: ["7M"],
			facade: ["7M"],
			flashcannon: ["7M"],
			harden: ["7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			lightscreen: ["7M"],
			protect: ["7M"],
			psychic: ["7M"],
			psywave: ["7L1"],
			reflect: ["7M"],
			rest: ["7M"],
			scald: ["7M"],
			substitute: ["7M"],
			surf: ["7M"],
			tackle: ["7L1"],
			teleport: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L1"],
		},
	},
	mrmime: {
		learnset: {
			barrier: ["7L1"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			confusion: ["7L1"],
			dazzlinggleam: ["7M"],
			doubleslap: ["7L10"],
			dreameater: ["7M"],
			encore: ["7L26"],
			facade: ["7M"],
			firepunch: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icepunch: ["7M"],
			lightscreen: ["7M", "7L36"],
			meditate: ["7L6"],
			mimic: ["7L16"],
			pound: ["7L1"],
			protect: ["7M"],
			psybeam: ["7L30"],
			psychic: ["7M", "7L46"],
			psywave: ["7L20"],
			reflect: ["7M", "7L36"],
			rest: ["7M"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M", "7L40"],
			taunt: ["7M"],
			teleport: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
		},
	},
	scyther: {
		learnset: {
			agility: ["7L20"],
			airslash: ["7L38"],
			brickbreak: ["7M"],
			doubleteam: ["7L8"],
			facade: ["7M"],
			feint: ["7L12"],
			focusenergy: ["7L4"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			leer: ["7L1"],
			lightscreen: ["7M"],
			protect: ["7M"],
			quickattack: ["7L1"],
			razorwind: ["7L32"],
			rest: ["7M"],
			roost: ["7M"],
			slash: ["7L26"],
			substitute: ["7M"],
			swordsdance: ["7L44"],
			toxic: ["7M"],
			uturn: ["7M"],
			wingattack: ["7L16"],
			xscissor: ["7M", "7L50"],
		},
	},
	jynx: {
		learnset: {
			blizzard: ["7M", "7L45"],
			bodyslam: ["7L30"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			confusion: ["7L12"],
			doubleslap: ["7L22"],
			dreameater: ["7M"],
			facade: ["7M"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M", "7L26"],
			lick: ["7L6"],
			lightscreen: ["7M"],
			lovelykiss: ["7L35"],
			pound: ["7L1"],
			protect: ["7M"],
			psychic: ["7M", "7L40"],
			reflect: ["7M"],
			rest: ["7M"],
			screech: ["7L18"],
			seismictoss: ["7M"],
			shadowball: ["7M"],
			substitute: ["7M"],
			taunt: ["7M"],
			teleport: ["7M"],
			toxic: ["7M"],
		},
	},
	electabuzz: {
		learnset: {
			brickbreak: ["7M"],
			facade: ["7M"],
			firepunch: ["7M"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			leer: ["7L1"],
			lightscreen: ["7M", "7L28"],
			lowkick: ["7L22"],
			protect: ["7M"],
			psychic: ["7M"],
			quickattack: ["7L6"],
			reflect: ["7M"],
			rest: ["7M"],
			screech: ["7L39"],
			seismictoss: ["7M"],
			substitute: ["7M"],
			swift: ["7L17"],
			taunt: ["7M"],
			teleport: ["7M"],
			thunder: ["7M", "7L50"],
			thunderbolt: ["7M", "7L44"],
			thunderpunch: ["7M", "7L33"],
			thundershock: ["7L1"],
			thunderwave: ["7M", "7L11"],
			toxic: ["7M"],
		},
	},
	magmar: {
		learnset: {
			brickbreak: ["7M"],
			clearsmog: ["7L17"],
			confuseray: ["7L39"],
			ember: ["7L1"],
			facade: ["7M"],
			fireblast: ["7M", "7L50"],
			firepunch: ["7M", "7L33"],
			firespin: ["7L28"],
			flamethrower: ["7M", "7L44"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			irontail: ["7M"],
			leer: ["7L1"],
			lowkick: ["7L22"],
			protect: ["7M"],
			psychic: ["7M"],
			rest: ["7M"],
			seismictoss: ["7M"],
			smog: ["7L6"],
			smokescreen: ["7L11"],
			substitute: ["7M"],
			taunt: ["7M"],
			teleport: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
			willowisp: ["7M"],
		},
	},
	pinsir: {
		learnset: {
			bind: ["7L4"],
			brickbreak: ["7M", "7L16"],
			bulkup: ["7M"],
			dig: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			focusenergy: ["7L1"],
			guillotine: ["7L50"],
			harden: ["7L12"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			outrage: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			seismictoss: ["7M", "7L8"],
			stealthrock: ["7M"],
			submission: ["7L26"],
			substitute: ["7M"],
			superpower: ["7M", "7L44"],
			swordsdance: ["7L32"],
			thrash: ["7L38"],
			toxic: ["7M"],
			visegrip: ["7L1"],
			xscissor: ["7M", "7L20"],
		},
	},
	tauros: {
		learnset: {
			blizzard: ["7M"],
			doubleedge: ["7L46"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			focusenergy: ["7L38"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hornattack: ["7L18"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			irontail: ["7M"],
			leer: ["7L24"],
			outrage: ["7M", "7L50"],
			protect: ["7M"],
			rage: ["7L12"],
			rest: ["7M", "7L30"],
			rockslide: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			surf: ["7M"],
			tackle: ["7L1"],
			tailwhip: ["7L6"],
			takedown: ["7L34"],
			thrash: ["7L42"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M"],
		},
	},
	magikarp: {
		learnset: {
			splash: ["7L1", "7S0"],
			tackle: ["7L15"],
		},
		eventData: [
			{generation: 7, level: 5, shiny: 1, ivs: {hp: 30, atk: 31, def: 25, spa: 25, spd: 25, spe: 31}, moves: ["splash"], pokeball: "pokeball"},
		],
	},
	gyarados: {
		learnset: {
			bind: ["7L16", "7L1"],
			bite: ["7L1", "7L0"],
			blizzard: ["7M"],
			crunch: ["7L36"],
			darkpulse: ["7M"],
			dragonpulse: ["7M"],
			dragonrage: ["7L11", "7L1"],
			dragontail: ["7M", "7L26"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			hydropump: ["7L46"],
			hyperbeam: ["7M", "7L51"],
			icebeam: ["7M"],
			irontail: ["7M"],
			leer: ["7L6", "7L1"],
			outrage: ["7M", "7L41"],
			protect: ["7M"],
			rage: ["7L21"],
			reflect: ["7M"],
			rest: ["7M"],
			scald: ["7M"],
			substitute: ["7M"],
			surf: ["7M"],
			taunt: ["7M"],
			thrash: ["7L1"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M", "7L31"],
		},
	},
	lapras: {
		learnset: {
			blizzard: ["7M", "7L58"],
			bodyslam: ["7L32", "7S0"],
			confuseray: ["7L26", "7S0"],
			dragonpulse: ["7M", "7L52"],
			dreameater: ["7M"],
			drillrun: ["7M"],
			facade: ["7M"],
			growl: ["7L6"],
			headbutt: ["7M"],
			hydropump: ["7L65"],
			hyperbeam: ["7M"],
			icebeam: ["7M", "7L39"],
			iceshard: ["7L19", "7S0"],
			irontail: ["7M"],
			megahorn: ["7M"],
			mist: ["7L13", "7S0"],
			outrage: ["7M"],
			protect: ["7M"],
			psychic: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			sing: ["7L1"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			surf: ["7M", "7L45"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L1"],
		},
		eventData: [
			{generation: 7, level: 34, shiny: 1, ivs: {hp: 31, atk: 25, def: 25, spa: 30, spd: 30, spe: 25}, moves: ["bodyslam", "confuseray", "iceshard", "mist"], pokeball: "pokeball"},
		],
	},
	ditto: {
		learnset: {
			transform: ["7L1"],
		},
	},
	eevee: {
		learnset: {
			bite: ["7L17"],
			dig: ["7M"],
			doubleedge: ["7L28"],
			doublekick: ["7L10"],
			facade: ["7M"],
			growl: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M", "7L31"],
			irontail: ["7M"],
			payday: ["7M"],
			protect: ["7M"],
			quickattack: ["7L6"],
			reflect: ["7M"],
			rest: ["7M"],
			sandattack: ["7L14"],
			shadowball: ["7M"],
			substitute: ["7M"],
			swift: ["7L21"],
			tackle: ["7L1"],
			tailwhip: ["7L3"],
			takedown: ["7L24"],
			toxic: ["7M"],
		},
	},
	eeveestarter: {
		inherit: true,
		learnset: {
			baddybad: ["7T"],
			bite: ["7L17"],
			bouncybubble: ["7T"],
			buzzybuzz: ["7T"],
			dig: ["7M"],
			doubleedge: ["7L28"],
			doublekick: ["7L10"],
			facade: ["7M"],
			freezyfrost: ["7T"],
			glitzyglow: ["7T"],
			growl: ["7L1", "7S0"],
			headbutt: ["7M"],
			helpinghand: ["7M", "7L31"],
			irontail: ["7M"],
			payday: ["7M"],
			protect: ["7M"],
			quickattack: ["7L6"],
			reflect: ["7M"],
			rest: ["7M"],
			sandattack: ["7L14"],
			sappyseed: ["7T"],
			shadowball: ["7M"],
			sizzlyslide: ["7T"],
			sparklyswirl: ["7T"],
			substitute: ["7M"],
			swift: ["7L21"],
			tackle: ["7L1", "7S0"],
			tailwhip: ["7L3", "7S0"],
			takedown: ["7L24"],
			toxic: ["7M"],
			veeveevolley: ["7T"],
		},
	},
	vaporeon: {
		learnset: {
			acidarmor: ["7L24"],
			aurorabeam: ["7L17"],
			blizzard: ["7M"],
			dig: ["7M"],
			doublekick: ["7L10"],
			facade: ["7M"],
			growl: ["7L1"],
			haze: ["7L21"],
			headbutt: ["7M"],
			helpinghand: ["7M", "7L28"],
			hydropump: ["7L31"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			irontail: ["7M"],
			payday: ["7M"],
			protect: ["7M"],
			quickattack: ["7L6"],
			reflect: ["7M"],
			rest: ["7M"],
			sandattack: ["7L14", "7L1"],
			scald: ["7M"],
			shadowball: ["7M"],
			substitute: ["7M"],
			surf: ["7M"],
			tackle: ["7L1"],
			tailwhip: ["7L3", "7L1"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L1", "7L0"],
			yawn: ["7L1"],
		},
	},
	jolteon: {
		learnset: {
			agility: ["7L24"],
			dig: ["7M"],
			doublekick: ["7L10"],
			facade: ["7M"],
			growl: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M", "7L28"],
			hyperbeam: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M"],
			payday: ["7M"],
			pinmissile: ["7L17"],
			protect: ["7M"],
			quickattack: ["7L6"],
			reflect: ["7M"],
			rest: ["7M"],
			sandattack: ["7L14", "7L1"],
			shadowball: ["7M"],
			substitute: ["7M"],
			tackle: ["7L1"],
			tailwhip: ["7L3", "7L1"],
			thunder: ["7M", "7L31"],
			thunderbolt: ["7M"],
			thundershock: ["7L1", "7L0"],
			thunderwave: ["7M", "7L21"],
			toxic: ["7M"],
			yawn: ["7L1"],
		},
	},
	flareon: {
		learnset: {
			dig: ["7M"],
			doublekick: ["7L10"],
			ember: ["7L1", "7L0"],
			facade: ["7M"],
			fireblast: ["7M"],
			firespin: ["7L17"],
			flamethrower: ["7M"],
			flareblitz: ["7L31"],
			focusenergy: ["7L24"],
			growl: ["7L1"],
			headbutt: ["7M"],
			helpinghand: ["7M", "7L28"],
			hyperbeam: ["7M"],
			irontail: ["7M"],
			payday: ["7M"],
			protect: ["7M"],
			quickattack: ["7L6"],
			reflect: ["7M"],
			rest: ["7M"],
			sandattack: ["7L14", "7L1"],
			shadowball: ["7M"],
			smog: ["7L21"],
			substitute: ["7M"],
			superpower: ["7M"],
			tackle: ["7L1"],
			tailwhip: ["7L3", "7L1"],
			toxic: ["7M"],
			willowisp: ["7M"],
			yawn: ["7L1"],
		},
	},
	porygon: {
		learnset: {
			agility: ["7L13"],
			barrier: ["7L18", "7S0"],
			blizzard: ["7M"],
			conversion: ["7L31", "7S0"],
			dreameater: ["7M"],
			facade: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M", "7L40"],
			icebeam: ["7M"],
			irontail: ["7M"],
			protect: ["7M"],
			psybeam: ["7L9"],
			psychic: ["7M"],
			recover: ["7L36"],
			reflect: ["7M"],
			rest: ["7M"],
			shadowball: ["7M"],
			sharpen: ["7L4"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			tackle: ["7L1"],
			teleport: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M", "7L27", "7S0"],
			toxic: ["7M"],
			triattack: ["7M", "7L22", "7S0"],
		},
		eventData: [
			{generation: 7, level: 34, shiny: 1, ivs: {hp: 25, atk: 25, def: 30, spa: 31, spd: 30, spe: 25}, moves: ["conversion", "thunderwave", "triattack", "barrier"], pokeball: "pokeball"},
		],
	},
	omanyte: {
		learnset: {
			bite: ["7L22"],
			blizzard: ["7M"],
			constrict: ["7L1"],
			facade: ["7M"],
			headbutt: ["7M"],
			hydropump: ["7L44", "7S0"],
			icebeam: ["7M"],
			leer: ["7L11"],
			protect: ["7M", "7L33", "7S0"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M", "7L37", "7S0"],
			rockthrow: ["7L26", "7S0"],
			scald: ["7M"],
			shellsmash: ["7L48"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			surf: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L15"],
			withdraw: ["7L4"],
		},
		eventData: [
			{generation: 7, level: 44, shiny: 1, perfectIVs: 3, moves: ["hydropump", "rockslide", "protect", "rockthrow"], pokeball: "pokeball"},
		],
	},
	omastar: {
		learnset: {
			bide: ["7L1"],
			bite: ["7L22"],
			blizzard: ["7M"],
			constrict: ["7L1"],
			facade: ["7M"],
			headbutt: ["7M"],
			hydropump: ["7L50"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			leer: ["7L11", "7L1"],
			protect: ["7M", "7L33"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M", "7L37"],
			rockthrow: ["7L26"],
			scald: ["7M"],
			seismictoss: ["7M"],
			shellsmash: ["7L60"],
			spikecannon: ["7L1", "7L0"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			supersonic: ["7L1"],
			surf: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L15", "7L1"],
			withdraw: ["7L4", "7L1"],
		},
	},
	kabuto: {
		learnset: {
			absorb: ["7L18"],
			aquajet: ["7L24", "7S0"],
			blizzard: ["7M"],
			dig: ["7M"],
			facade: ["7M"],
			harden: ["7L6"],
			headbutt: ["7M"],
			icebeam: ["7M"],
			leechlife: ["7L48"],
			leer: ["7L12"],
			megadrain: ["7M"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M", "7L42", "7S0"],
			rockthrow: ["7L30", "7S0"],
			sandattack: ["7L36", "7S0"],
			scald: ["7M"],
			scratch: ["7L1"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			surf: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
		},
		eventData: [
			{generation: 7, level: 44, shiny: 1, perfectIVs: 3, moves: ["rockslide", "sandattack", "rockthrow", "aquajet"], pokeball: "pokeball"},
		],
	},
	kabutops: {
		learnset: {
			absorb: ["7L18", "7L1"],
			aquajet: ["7L24"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			confuseray: ["7L1"],
			dig: ["7M"],
			facade: ["7M"],
			feint: ["7L1"],
			harden: ["7L6", "7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			leechlife: ["7L54"],
			leer: ["7L12", "7L1"],
			megadrain: ["7M"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M", "7L45"],
			rockthrow: ["7L30"],
			sandattack: ["7L36"],
			scald: ["7M"],
			scratch: ["7L1"],
			screech: ["7L1"],
			seismictoss: ["7M"],
			slash: ["7L1", "7L0"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			superpower: ["7M"],
			surf: ["7M"],
			swordsdance: ["7L63"],
			toxic: ["7M"],
			waterfall: ["7M"],
			xscissor: ["7M"],
		},
	},
	aerodactyl: {
		learnset: {
			agility: ["7L28", "7S0"],
			bite: ["7L1"],
			crunch: ["7L35", "7S0"],
			dragonpulse: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			fly: ["7M", "7L49"],
			headbutt: ["7M"],
			hyperbeam: ["7M", "7L63"],
			irontail: ["7M"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			roar: ["7L7"],
			rockslide: ["7M", "7L42", "7S0"],
			rockthrow: ["7L21", "7S0"],
			roost: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			supersonic: ["7L14"],
			takedown: ["7L56"],
			taunt: ["7M"],
			toxic: ["7M"],
			wingattack: ["7L1"],
		},
		eventData: [
			{generation: 7, level: 44, shiny: 1, perfectIVs: 3, moves: ["rockslide", "crunch", "rockthrow", "agility"], pokeball: "pokeball"},
		],
	},
	snorlax: {
		learnset: {
			amnesia: ["7L45"],
			blizzard: ["7M"],
			bodyslam: ["7L52"],
			brickbreak: ["7M"],
			crunch: ["7L58"],
			defensecurl: ["7L6"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M", "7L26", "7S1", "7S0"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			lick: ["7L19", "7S1", "7S0"],
			outrage: ["7M"],
			payday: ["7M"],
			protect: ["7M"],
			psychic: ["7M"],
			reflect: ["7M"],
			rest: ["7M", "7L32", "7S1", "7S0"],
			rockslide: ["7M"],
			screech: ["7L39"],
			seismictoss: ["7M"],
			selfdestruct: ["7M"],
			shadowball: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			superpower: ["7M", "7L65"],
			surf: ["7M"],
			tackle: ["7L1"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			toxic: ["7M"],
			yawn: ["7L13", "7S1", "7S0"],
		},
		eventData: [
			{generation: 7, level: 34, shiny: 1, perfectIVs: 3, moves: ["rest", "headbutt", "lick", "yawn"]},
			{generation: 7, level: 34, shiny: 1, perfectIVs: 3, moves: ["rest", "headbutt", "lick", "yawn"]},
		],
	},
	articuno: {
		learnset: {
			agility: ["7L40", "7S0"],
			blizzard: ["7M", "7L64"],
			facade: ["7M"],
			fly: ["7M"],
			gust: ["7L1"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M", "7L32", "7S0"],
			iceshard: ["7L1"],
			leer: ["7L16"],
			mirrorcoat: ["7L24", "7S0"],
			mist: ["7L8"],
			protect: ["7M"],
			reflect: ["7M", "7L48", "7S0"],
			rest: ["7M"],
			roost: ["7M", "7L56"],
			skyattack: ["7L72"],
			substitute: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
		eventData: [
			{generation: 7, level: 50, shiny: 1, perfectIVs: 3, moves: ["reflect", "agility", "icebeam", "mirrorcoat"]},
		],
		eventOnly: false,
	},
	zapdos: {
		learnset: {
			agility: ["7L40", "7S0"],
			drillpeck: ["7L24", "7S0"],
			facade: ["7M"],
			fly: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			leer: ["7L16"],
			lightscreen: ["7M", "7L48", "7S0"],
			peck: ["7L1"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			roost: ["7M", "7L56"],
			skyattack: ["7L72"],
			substitute: ["7M"],
			thunder: ["7M", "7L64"],
			thunderbolt: ["7M", "7L32", "7S0"],
			thundershock: ["7L1"],
			thunderwave: ["7M", "7L8"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
		eventData: [
			{generation: 7, level: 50, shiny: 1, perfectIVs: 3, moves: ["lightscreen", "agility", "thunderbolt", "drillpeck"]},
		],
		eventOnly: false,
	},
	moltres: {
		learnset: {
			agility: ["7L40", "7S0"],
			airslash: ["7L24", "7S0"],
			ember: ["7L1"],
			facade: ["7M"],
			fireblast: ["7M"],
			firespin: ["7L8"],
			flamethrower: ["7M", "7L32", "7S0"],
			fly: ["7M"],
			headbutt: ["7M"],
			heatwave: ["7L48", "7S0"],
			hyperbeam: ["7M"],
			leer: ["7L16"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			roost: ["7M", "7L56"],
			skyattack: ["7L72"],
			solarbeam: ["7M", "7L64"],
			substitute: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			willowisp: ["7M"],
			wingattack: ["7L1"],
		},
		eventData: [
			{generation: 7, level: 50, shiny: 1, perfectIVs: 3, moves: ["heatwave", "agility", "flamethrower", "airslash"]},
		],
		eventOnly: false,
	},
	dratini: {
		learnset: {
			agility: ["7L21"],
			blizzard: ["7M"],
			dragonpulse: ["7M"],
			dragonrage: ["7L14"],
			dragontail: ["7M", "7L28"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M", "7L49"],
			icebeam: ["7M"],
			irontail: ["7M"],
			leer: ["7L1"],
			lightscreen: ["7M"],
			outrage: ["7M", "7L42"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			slam: ["7L35"],
			substitute: ["7M"],
			surf: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M", "7L7"],
			toxic: ["7M"],
			waterfall: ["7M"],
			wrap: ["7L1"],
		},
	},
	dragonair: {
		learnset: {
			agility: ["7L21"],
			blizzard: ["7M"],
			dragonpulse: ["7M"],
			dragonrage: ["7L14", "7L1"],
			dragontail: ["7M", "7L28"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M", "7L64"],
			icebeam: ["7M"],
			irontail: ["7M"],
			leer: ["7L1"],
			lightscreen: ["7M"],
			outrage: ["7M", "7L52"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			slam: ["7L40"],
			substitute: ["7M"],
			surf: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M", "7L7", "7L1"],
			toxic: ["7M"],
			waterfall: ["7M"],
			wrap: ["7L1"],
		},
	},
	dragonite: {
		learnset: {
			agility: ["7L21"],
			aquajet: ["7L1"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			dragonpulse: ["7M"],
			dragonrage: ["7L14", "7L1"],
			dragontail: ["7M", "7L28"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M", "7L1"],
			flamethrower: ["7M"],
			fly: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M", "7L70"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			leer: ["7L1"],
			lightscreen: ["7M"],
			mist: ["7L1"],
			outrage: ["7M", "7L52"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			roost: ["7M", "7L88"],
			slam: ["7L40"],
			substitute: ["7M"],
			superpower: ["7M"],
			surf: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M", "7L1"],
			thunderwave: ["7M", "7L7", "7L1"],
			toxic: ["7M"],
			waterfall: ["7M"],
			wingattack: ["7L1", "7L0"],
			wrap: ["7L1"],
		},
	},
	mewtwo: {
		learnset: {
			agility: ["7L88"],
			amnesia: ["7L44", "7S0"],
			barrier: ["7L77"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			bulkup: ["7M"],
			calmmind: ["7M", "7L99"],
			confuseray: ["7L1"],
			confusion: ["7L1"],
			disable: ["7L1"],
			dreameater: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M"],
			mist: ["7L11"],
			payday: ["7M"],
			poisonjab: ["7M"],
			protect: ["7M"],
			psybeam: ["7L22"],
			psychic: ["7M", "7L66", "7S0"],
			psywave: ["7L1"],
			recover: ["7L55", "7S0"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			seismictoss: ["7M"],
			selfdestruct: ["7M"],
			shadowball: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			swift: ["7L33", "7S0"],
			taunt: ["7M"],
			teleport: ["7M", "7L1"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7M"],
			willowisp: ["7M"],
		},
		eventData: [
			{generation: 7, level: 70, shiny: 1, perfectIVs: 3, moves: ["psychic", "recover", "amnesia", "swift"]},
		],
	},
	mew: {
		learnset: {
			amnesia: ["7L22"],
			barrier: ["7L44"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			bulkup: ["7M"],
			calmmind: ["7M"],
			confusion: ["7L1"],
			darkpulse: ["7M"],
			dazzlinggleam: ["7M"],
			dig: ["7M"],
			dragonpulse: ["7M"],
			dragontail: ["7M"],
			dreameater: ["7M"],
			drillrun: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			firepunch: ["7M"],
			flamethrower: ["7M"],
			flashcannon: ["7M"],
			fly: ["7M"],
			foulplay: ["7M"],
			headbutt: ["7M"],
			helpinghand: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			irontail: ["7M"],
			lightscreen: ["7M"],
			megadrain: ["7M"],
			megahorn: ["7M"],
			megapunch: ["7L55"],
			metronome: ["7L66"],
			mimic: ["7L1"],
			nastyplot: ["7L88"],
			outrage: ["7M"],
			payday: ["7M"],
			playrough: ["7M"],
			poisonjab: ["7M"],
			pound: ["7L1", "7S0"],
			protect: ["7M"],
			psychic: ["7M", "7L77"],
			psywave: ["7L33"],
			reflect: ["7M"],
			rest: ["7M"],
			rockslide: ["7M"],
			roost: ["7M"],
			scald: ["7M"],
			seismictoss: ["7M"],
			selfdestruct: ["7M"],
			shadowball: ["7M"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			stealthrock: ["7M"],
			substitute: ["7M"],
			superpower: ["7M"],
			surf: ["7M"],
			swift: ["7L11"],
			taunt: ["7M"],
			teleport: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			transform: ["7L99"],
			triattack: ["7M"],
			uturn: ["7M"],
			waterfall: ["7M"],
			willowisp: ["7M"],
			xscissor: ["7M"],
		},
		eventData: [
			{generation: 7, level: 1, perfectIVs: 3, moves: ["pound"], pokeball: "pokeball"},
		],
	},
	meltan: {
		learnset: {
			acidarmor: ["7L36"],
			flashcannon: ["7M", "7L45"],
			harden: ["7L1"],
			headbutt: ["7M", "7L1"],
			protect: ["7M"],
			rest: ["7M"],
			substitute: ["7M"],
			tailwhip: ["7L9"],
			thunderbolt: ["7M"],
			thundershock: ["7L27"],
			thunderwave: ["7M", "7L18"],
			toxic: ["7M"],
		},
	},
	melmetal: {
		learnset: {
			acidarmor: ["7L36"],
			brickbreak: ["7M"],
			doubleironbash: ["7L72"],
			earthquake: ["7M"],
			facade: ["7M"],
			flashcannon: ["7M", "7L45"],
			harden: ["7L1"],
			headbutt: ["7M", "7L1"],
			hyperbeam: ["7M", "7L90"],
			icebeam: ["7M"],
			icepunch: ["7M"],
			megapunch: ["7L54"],
			protect: ["7M", "7L63"],
			rest: ["7M"],
			rockslide: ["7M"],
			selfdestruct: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			superpower: ["7M", "7L81"],
			tailwhip: ["7L9", "7L1"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7M", "7L1", "7L0"],
			thundershock: ["7L27"],
			thunderwave: ["7M", "7L18", "7L1"],
			toxic: ["7M"],
		},
	},
};
